/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChangePasswordDto,
  CreateCustomerDto,
  CreateOrderDto,
  CreatePaymentDto,
  CreatePermissionDto,
  CreateProductCategoryDto,
  CreateProductDto,
  CreateRoleDto,
  CreateSocialNetworkDto,
  CreateStoreDto,
  CreateStoreInviteDto,
  CreateUserDto,
  CustomerInfoDto,
  ExportCustomersParams,
  ExportOrdersParams,
  ExportProductsParams,
  GetBillingInvoicesParams,
  GetCommissionsParams,
  GetCustomerStatsParams,
  GetCustomersParams,
  GetDashboardSummaryParams,
  GetOrderStatsParams,
  GetOrdersParams,
  GetPermissionsParams,
  GetProductCategoriesParams,
  GetProductStatsParams,
  GetProductsParams,
  GetRolesParams,
  GetSocialNetworksParams,
  GetStoresParams,
  GetUsersParams,
  HasPermissionDto,
  OkBaseResponse,
  RequestCheckoutOtpDto,
  RequestOtpDto,
  ResponseAcceptInviteDto,
  ResponseBillingConfigDto,
  ResponseBillingInvoicesDto,
  ResponseBillingPayDto,
  ResponseBillingShopsDto,
  ResponseBillingSummaryDto,
  ResponseCommissionsDto,
  ResponseCustomerArrayDto,
  ResponseCustomerDto,
  ResponseCustomerStatsDto,
  ResponseDashboardSummaryDto,
  ResponseHasPermissionDto,
  ResponseInstagramAccountDto,
  ResponseInstagramConnectUrlDto,
  ResponseLoginDto,
  ResponseLogoutDto,
  ResponseMeDto,
  ResponseOrderArrayDto,
  ResponseOrderDto,
  ResponseOrderStatsDto,
  ResponsePaymentArrayDto,
  ResponsePaymentDto,
  ResponsePaymentLinkDto,
  ResponsePermissionArrayDto,
  ResponsePermissionDto,
  ResponseProductArrayDto,
  ResponseProductCategoryArrayDto,
  ResponseProductCategoryDto,
  ResponseProductDto,
  ResponseProductStatsDto,
  ResponsePublicCheckoutDto,
  ResponsePublicInviteDto,
  ResponsePublicOtpDto,
  ResponsePublicPayDto,
  ResponsePublicResultDto,
  ResponsePublicTrackingDto,
  ResponseRegisterDto,
  ResponseRequestOtpDto,
  ResponseReverseGeocodeDto,
  ResponseRoleArrayDto,
  ResponseRoleDto,
  ResponseSocialNetworkArrayDto,
  ResponseSocialNetworkDto,
  ResponseStoreArrayDto,
  ResponseStoreDto,
  ResponseStoreInviteDto,
  ResponseStoreInviteViewDto,
  ResponseStoreInviteViewsDto,
  ResponseStoreMemberDto,
  ResponseStoreMembersDto,
  ResponseStoreSettingsDto,
  ResponseTeamRolesDto,
  ResponseUserArrayDto,
  ResponseUserDto,
  ReverseGeocodePublicCheckoutParams,
  ScheduleStoreDeleteDto,
  UpdateCustomerDto,
  UpdateMemberRoleDto,
  UpdateOrderDto,
  UpdateOrderStatusDto,
  UpdatePermissionDto,
  UpdateProductCategoryDto,
  UpdateProductDto,
  UpdateRoleDto,
  UpdateSocialNetworkDto,
  UpdateStoreDto,
  UpdateStoreSettingsDto,
  UpdateUserDto,
  UploadFileDto,
  UploadImageBody,
  UploadResponseDto,
  UserLoginDto,
  UserRegisterDto,
  VerifyCheckoutOtpDto,
  VerifyOtpDto,
  VerifyPaymentDto
} from './schemas';
import { customInstance } from '../lib/api/orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type appControllerGetHelloResponse200 = {
  data: void
  status: 200
}

export type appControllerGetHelloResponseSuccess = (appControllerGetHelloResponse200) & {
  headers: Headers;
};
;

export type appControllerGetHelloResponse = (appControllerGetHelloResponseSuccess)

export const getAppControllerGetHelloUrl = () => {




  return `/`
}

export const appControllerGetHello = async ( options?: RequestInit): Promise<appControllerGetHelloResponse> => {

  return customInstance<appControllerGetHelloResponse>(getAppControllerGetHelloUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAppControllerGetHelloQueryKey = () => {
    return [
    `/`
    ] as const;
    }


export const getAppControllerGetHelloQueryOptions = <TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppControllerGetHelloQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetHello>>> = ({ signal }) => appControllerGetHello({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AppControllerGetHelloQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetHello>>>
export type AppControllerGetHelloQueryError = unknown


export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof appControllerGetHello>>,
          TError,
          Awaited<ReturnType<typeof appControllerGetHello>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAppControllerGetHello<TData = Awaited<ReturnType<typeof appControllerGetHello>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAppControllerGetHelloQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ایجاد کاربر جدید
 */
export type createUserResponse201 = {
  data: ResponseUserDto
  status: 201
}

export type createUserResponseSuccess = (createUserResponse201) & {
  headers: Headers;
};
;

export type createUserResponse = (createUserResponseSuccess)

export const getCreateUserUrl = () => {




  return `/users`
}

export const createUser = async (createUserDto: CreateUserDto, options?: RequestInit): Promise<createUserResponse> => {

  return customInstance<createUserResponse>(getCreateUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserDto,)
  }
);}




export const getCreateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDto}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: CreateUserDto}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = CreateUserDto
    export type CreateUserMutationError = unknown

    /**
 * @summary ایجاد کاربر جدید
 */
export const useCreateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: CreateUserDto},
        TContext
      > => {
      return useMutation(getCreateUserMutationOptions(options), queryClient);
    }

/**
 * @summary لیست تمام کاربران
 */
export type getUsersResponse200 = {
  data: ResponseUserArrayDto
  status: 200
}

export type getUsersResponseSuccess = (getUsersResponse200) & {
  headers: Headers;
};
;

export type getUsersResponse = (getUsersResponseSuccess)

export const getGetUsersUrl = (params?: GetUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/users?${stringifiedParams}` : `/users`
}

export const getUsers = async (params?: GetUsersParams, options?: RequestInit): Promise<getUsersResponse> => {

  return customInstance<getUsersResponse>(getGetUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [
    `/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = unknown


export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست تمام کاربران
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary اطلاعات کاربر
 */
export type getUserResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type getUserResponseSuccess = (getUserResponse200) & {
  headers: Headers;
};
;

export type getUserResponse = (getUserResponseSuccess)

export const getGetUserUrl = (id: string,) => {




  return `/users/${id}`
}

export const getUser = async (id: string, options?: RequestInit): Promise<getUserResponse> => {

  return customInstance<getUserResponse>(getGetUserUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserQueryKey = (id: string,) => {
    return [
    `/users/${id}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = unknown


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary اطلاعات کاربر
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ویرایش کاربر
 */
export type updateUserResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type updateUserResponseSuccess = (updateUserResponse200) & {
  headers: Headers;
};
;

export type updateUserResponse = (updateUserResponseSuccess)

export const getUpdateUserUrl = (id: string,) => {




  return `/users/${id}`
}

export const updateUser = async (id: string,
    updateUserDto: UpdateUserDto, options?: RequestInit): Promise<updateUserResponse> => {

  return customInstance<updateUserResponse>(getUpdateUserUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateUserDto,)
  }
);}




export const getUpdateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserDto}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUser>>, {id: string;data: UpdateUserDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUser(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateUser>>>
    export type UpdateUserMutationBody = UpdateUserDto
    export type UpdateUserMutationError = unknown

    /**
 * @summary ویرایش کاربر
 */
export const useUpdateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUser>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUser>>,
        TError,
        {id: string;data: UpdateUserDto},
        TContext
      > => {
      return useMutation(getUpdateUserMutationOptions(options), queryClient);
    }

/**
 * @summary حذف کاربر
 */
export type deleteUserResponse200 = {
  data: ResponseUserDto
  status: 200
}

export type deleteUserResponseSuccess = (deleteUserResponse200) & {
  headers: Headers;
};
;

export type deleteUserResponse = (deleteUserResponseSuccess)

export const getDeleteUserUrl = (id: string,) => {




  return `/users/${id}`
}

export const deleteUser = async (id: string, options?: RequestInit): Promise<deleteUserResponse> => {

  return customInstance<deleteUserResponse>(getDeleteUserUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUser(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = unknown

    /**
 * @summary حذف کاربر
 */
export const useDeleteUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options), queryClient);
    }

/**
 * @summary ثبت نام کاربر جدید
 */
export type registerResponse200 = {
  data: ResponseRegisterDto
  status: 200
}

export type registerResponseSuccess = (registerResponse200) & {
  headers: Headers;
};
;

export type registerResponse = (registerResponseSuccess)

export const getRegisterUrl = () => {




  return `/auth/register`
}

export const register = async (userRegisterDto: UserRegisterDto, options?: RequestInit): Promise<registerResponse> => {

  return customInstance<registerResponse>(getRegisterUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userRegisterDto,)
  }
);}




export const getRegisterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: UserRegisterDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: UserRegisterDto}, TContext> => {

const mutationKey = ['register'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof register>>, {data: UserRegisterDto}> = (props) => {
          const {data} = props ?? {};

          return  register(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterMutationResult = NonNullable<Awaited<ReturnType<typeof register>>>
    export type RegisterMutationBody = UserRegisterDto
    export type RegisterMutationError = unknown

    /**
 * @summary ثبت نام کاربر جدید
 */
export const useRegister = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: UserRegisterDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof register>>,
        TError,
        {data: UserRegisterDto},
        TContext
      > => {
      return useMutation(getRegisterMutationOptions(options), queryClient);
    }

/**
 * @summary درخواست کد یک‌بارمصرف
 */
export type requestOtpResponse200 = {
  data: ResponseRequestOtpDto
  status: 200
}

export type requestOtpResponseSuccess = (requestOtpResponse200) & {
  headers: Headers;
};
;

export type requestOtpResponse = (requestOtpResponseSuccess)

export const getRequestOtpUrl = () => {




  return `/auth/otp/request`
}

export const requestOtp = async (requestOtpDto: RequestOtpDto, options?: RequestInit): Promise<requestOtpResponse> => {

  return customInstance<requestOtpResponse>(getRequestOtpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      requestOtpDto,)
  }
);}




export const getRequestOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestOtp>>, TError,{data: RequestOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestOtp>>, TError,{data: RequestOtpDto}, TContext> => {

const mutationKey = ['requestOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestOtp>>, {data: RequestOtpDto}> = (props) => {
          const {data} = props ?? {};

          return  requestOtp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestOtpMutationResult = NonNullable<Awaited<ReturnType<typeof requestOtp>>>
    export type RequestOtpMutationBody = RequestOtpDto
    export type RequestOtpMutationError = unknown

    /**
 * @summary درخواست کد یک‌بارمصرف
 */
export const useRequestOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestOtp>>, TError,{data: RequestOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestOtp>>,
        TError,
        {data: RequestOtpDto},
        TContext
      > => {
      return useMutation(getRequestOtpMutationOptions(options), queryClient);
    }

/**
 * @summary تأیید کد و ورود/ثبت‌نام
 */
export type verifyOtpResponse200 = {
  data: ResponseLoginDto
  status: 200
}

export type verifyOtpResponseSuccess = (verifyOtpResponse200) & {
  headers: Headers;
};
;

export type verifyOtpResponse = (verifyOtpResponseSuccess)

export const getVerifyOtpUrl = () => {




  return `/auth/otp/verify`
}

export const verifyOtp = async (verifyOtpDto: VerifyOtpDto, options?: RequestInit): Promise<verifyOtpResponse> => {

  return customInstance<verifyOtpResponse>(getVerifyOtpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verifyOtpDto,)
  }
);}




export const getVerifyOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOtp>>, TError,{data: VerifyOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyOtp>>, TError,{data: VerifyOtpDto}, TContext> => {

const mutationKey = ['verifyOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyOtp>>, {data: VerifyOtpDto}> = (props) => {
          const {data} = props ?? {};

          return  verifyOtp(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyOtp>>>
    export type VerifyOtpMutationBody = VerifyOtpDto
    export type VerifyOtpMutationError = unknown

    /**
 * @summary تأیید کد و ورود/ثبت‌نام
 */
export const useVerifyOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyOtp>>, TError,{data: VerifyOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyOtp>>,
        TError,
        {data: VerifyOtpDto},
        TContext
      > => {
      return useMutation(getVerifyOtpMutationOptions(options), queryClient);
    }

/**
 * @summary ورود کاربر
 */
export type loginResponse200 = {
  data: ResponseLoginDto
  status: 200
}

export type loginResponseSuccess = (loginResponse200) & {
  headers: Headers;
};
;

export type loginResponse = (loginResponseSuccess)

export const getLoginUrl = () => {




  return `/auth/login`
}

export const login = async (userLoginDto: UserLoginDto, options?: RequestInit): Promise<loginResponse> => {

  return customInstance<loginResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userLoginDto,)
  }
);}




export const getLoginMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: UserLoginDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: UserLoginDto}, TContext> => {

const mutationKey = ['login'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, {data: UserLoginDto}> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = UserLoginDto
    export type LoginMutationError = unknown

    /**
 * @summary ورود کاربر
 */
export const useLogin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,{data: UserLoginDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        {data: UserLoginDto},
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }

/**
 * @summary خروج کاربر
 */
export type logoutResponse200 = {
  data: ResponseLogoutDto
  status: 200
}

export type logoutResponseSuccess = (logoutResponse200) & {
  headers: Headers;
};
;

export type logoutResponse = (logoutResponseSuccess)

export const getLogoutUrl = () => {




  return `/auth/logout`
}

export const logout = async ( options?: RequestInit): Promise<logoutResponse> => {

  return customInstance<logoutResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = ['logout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = unknown

    /**
 * @summary خروج کاربر
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }

/**
 * @summary تازه سازی توکن
 */
export type refreshResponse200 = {
  data: ResponseLoginDto
  status: 200
}

export type refreshResponseSuccess = (refreshResponse200) & {
  headers: Headers;
};
;

export type refreshResponse = (refreshResponseSuccess)

export const getRefreshUrl = () => {




  return `/auth/refresh`
}

export const refresh = async ( options?: RequestInit): Promise<refreshResponse> => {

  return customInstance<refreshResponse>(getRefreshUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRefreshMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext> => {

const mutationKey = ['refresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refresh>>, void> = () => {


          return  refresh(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshMutationResult = NonNullable<Awaited<ReturnType<typeof refresh>>>

    export type RefreshMutationError = unknown

    /**
 * @summary تازه سازی توکن
 */
export const useRefresh = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refresh>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof refresh>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getRefreshMutationOptions(options), queryClient);
    }

/**
 * @summary اطلاعات کاربر جاری
 */
export type getMeResponse200 = {
  data: ResponseMeDto
  status: 200
}

export type getMeResponseSuccess = (getMeResponse200) & {
  headers: Headers;
};
;

export type getMeResponse = (getMeResponseSuccess)

export const getGetMeUrl = () => {




  return `/auth/me`
}

export const getMe = async ( options?: RequestInit): Promise<getMeResponse> => {

  return customInstance<getMeResponse>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/auth/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = unknown


export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMe>>,
          TError,
          Awaited<ReturnType<typeof getMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary اطلاعات کاربر جاری
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary تغییر رمز عبور
 */
export type changePasswordResponse200 = {
  data: OkBaseResponse
  status: 200
}

export type changePasswordResponseSuccess = (changePasswordResponse200) & {
  headers: Headers;
};
;

export type changePasswordResponse = (changePasswordResponseSuccess)

export const getChangePasswordUrl = () => {




  return `/auth/change-password`
}

export const changePassword = async (changePasswordDto: ChangePasswordDto, options?: RequestInit): Promise<changePasswordResponse> => {

  return customInstance<changePasswordResponse>(getChangePasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      changePasswordDto,)
  }
);}




export const getChangePasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordDto}, TContext> => {

const mutationKey = ['changePassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changePassword>>, {data: ChangePasswordDto}> = (props) => {
          const {data} = props ?? {};

          return  changePassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangePasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changePassword>>>
    export type ChangePasswordMutationBody = ChangePasswordDto
    export type ChangePasswordMutationError = unknown

    /**
 * @summary تغییر رمز عبور
 */
export const useChangePassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changePassword>>, TError,{data: ChangePasswordDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changePassword>>,
        TError,
        {data: ChangePasswordDto},
        TContext
      > => {
      return useMutation(getChangePasswordMutationOptions(options), queryClient);
    }

/**
 * @summary بررسی دسترسی کاربر
 */
export type checkPermissionResponse200 = {
  data: ResponseHasPermissionDto
  status: 200
}

export type checkPermissionResponseSuccess = (checkPermissionResponse200) & {
  headers: Headers;
};
;

export type checkPermissionResponse = (checkPermissionResponseSuccess)

export const getCheckPermissionUrl = () => {




  return `/auth/has-permission`
}

export const checkPermission = async (hasPermissionDto: HasPermissionDto, options?: RequestInit): Promise<checkPermissionResponse> => {

  return customInstance<checkPermissionResponse>(getCheckPermissionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      hasPermissionDto,)
  }
);}




export const getCheckPermissionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkPermission>>, TError,{data: HasPermissionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof checkPermission>>, TError,{data: HasPermissionDto}, TContext> => {

const mutationKey = ['checkPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkPermission>>, {data: HasPermissionDto}> = (props) => {
          const {data} = props ?? {};

          return  checkPermission(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckPermissionMutationResult = NonNullable<Awaited<ReturnType<typeof checkPermission>>>
    export type CheckPermissionMutationBody = HasPermissionDto
    export type CheckPermissionMutationError = unknown

    /**
 * @summary بررسی دسترسی کاربر
 */
export const useCheckPermission = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkPermission>>, TError,{data: HasPermissionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkPermission>>,
        TError,
        {data: HasPermissionDto},
        TContext
      > => {
      return useMutation(getCheckPermissionMutationOptions(options), queryClient);
    }

/**
 * @summary ساخت نقش جدید
 */
export type createRoleResponse201 = {
  data: ResponseRoleDto
  status: 201
}

export type createRoleResponseSuccess = (createRoleResponse201) & {
  headers: Headers;
};
;

export type createRoleResponse = (createRoleResponseSuccess)

export const getCreateRoleUrl = () => {




  return `/roles`
}

export const createRole = async (createRoleDto: CreateRoleDto, options?: RequestInit): Promise<createRoleResponse> => {

  return customInstance<createRoleResponse>(getCreateRoleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createRoleDto,)
  }
);}




export const getCreateRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext> => {

const mutationKey = ['createRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRole>>, {data: CreateRoleDto}> = (props) => {
          const {data} = props ?? {};

          return  createRole(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createRole>>>
    export type CreateRoleMutationBody = CreateRoleDto
    export type CreateRoleMutationError = unknown

    /**
 * @summary ساخت نقش جدید
 */
export const useCreateRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRole>>,
        TError,
        {data: CreateRoleDto},
        TContext
      > => {
      return useMutation(getCreateRoleMutationOptions(options), queryClient);
    }

/**
 * @summary لیست تمام نقش‌ها
 */
export type getRolesResponse200 = {
  data: ResponseRoleArrayDto
  status: 200
}

export type getRolesResponseSuccess = (getRolesResponse200) & {
  headers: Headers;
};
;

export type getRolesResponse = (getRolesResponseSuccess)

export const getGetRolesUrl = (params?: GetRolesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/roles?${stringifiedParams}` : `/roles`
}

export const getRoles = async (params?: GetRolesParams, options?: RequestInit): Promise<getRolesResponse> => {

  return customInstance<getRolesResponse>(getGetRolesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRolesQueryKey = (params?: GetRolesParams,) => {
    return [
    `/roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRolesQueryOptions = <TData = Awaited<ReturnType<typeof getRoles>>, TError = unknown>(params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRolesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoles>>> = ({ signal }) => getRoles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getRoles>>>
export type GetRolesQueryError = unknown


export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = unknown>(
 params: undefined |  GetRolesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = unknown>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = unknown>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست تمام نقش‌ها
 */

export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = unknown>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRolesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary گرفتن اطلاعات نقش
 */
export type getRoleResponse200 = {
  data: ResponseRoleDto
  status: 200
}

export type getRoleResponseSuccess = (getRoleResponse200) & {
  headers: Headers;
};
;

export type getRoleResponse = (getRoleResponseSuccess)

export const getGetRoleUrl = (id: string,) => {




  return `/roles/${id}`
}

export const getRole = async (id: string, options?: RequestInit): Promise<getRoleResponse> => {

  return customInstance<getRoleResponse>(getGetRoleUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRoleQueryKey = (id: string,) => {
    return [
    `/roles/${id}`
    ] as const;
    }


export const getGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRole>>> = ({ signal }) => getRole(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRole>>>
export type GetRoleQueryError = unknown


export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRole>>,
          TError,
          Awaited<ReturnType<typeof getRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRole>>,
          TError,
          Awaited<ReturnType<typeof getRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گرفتن اطلاعات نقش
 */

export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary به‌روزرسانی نقش
 */
export type updateRoleResponse200 = {
  data: ResponseRoleDto
  status: 200
}

export type updateRoleResponseSuccess = (updateRoleResponse200) & {
  headers: Headers;
};
;

export type updateRoleResponse = (updateRoleResponseSuccess)

export const getUpdateRoleUrl = (id: string,) => {




  return `/roles/${id}`
}

export const updateRole = async (id: string,
    updateRoleDto: UpdateRoleDto, options?: RequestInit): Promise<updateRoleResponse> => {

  return customInstance<updateRoleResponse>(getUpdateRoleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateRoleDto,)
  }
);}




export const getUpdateRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleDto}, TContext> => {

const mutationKey = ['updateRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRole>>, {id: string;data: UpdateRoleDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateRole(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateRole>>>
    export type UpdateRoleMutationBody = UpdateRoleDto
    export type UpdateRoleMutationError = unknown

    /**
 * @summary به‌روزرسانی نقش
 */
export const useUpdateRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRole>>, TError,{id: string;data: UpdateRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateRole>>,
        TError,
        {id: string;data: UpdateRoleDto},
        TContext
      > => {
      return useMutation(getUpdateRoleMutationOptions(options), queryClient);
    }

/**
 * @summary حذف نقش
 */
export type deleteRoleResponse200 = {
  data: ResponseRoleDto
  status: 200
}

export type deleteRoleResponseSuccess = (deleteRoleResponse200) & {
  headers: Headers;
};
;

export type deleteRoleResponse = (deleteRoleResponseSuccess)

export const getDeleteRoleUrl = (id: string,) => {




  return `/roles/${id}`
}

export const deleteRole = async (id: string, options?: RequestInit): Promise<deleteRoleResponse> => {

  return customInstance<deleteRoleResponse>(getDeleteRoleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRole>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteRole(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRole>>>

    export type DeleteRoleMutationError = unknown

    /**
 * @summary حذف نقش
 */
export const useDeleteRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRole>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteRoleMutationOptions(options), queryClient);
    }

/**
 * @summary ساخت دسترسی جدید
 */
export type createPermissionResponse201 = {
  data: ResponsePermissionDto
  status: 201
}

export type createPermissionResponseSuccess = (createPermissionResponse201) & {
  headers: Headers;
};
;

export type createPermissionResponse = (createPermissionResponseSuccess)

export const getCreatePermissionUrl = () => {




  return `/permissions`
}

export const createPermission = async (createPermissionDto: CreatePermissionDto, options?: RequestInit): Promise<createPermissionResponse> => {

  return customInstance<createPermissionResponse>(getCreatePermissionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPermissionDto,)
  }
);}




export const getCreatePermissionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermission>>, TError,{data: CreatePermissionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPermission>>, TError,{data: CreatePermissionDto}, TContext> => {

const mutationKey = ['createPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPermission>>, {data: CreatePermissionDto}> = (props) => {
          const {data} = props ?? {};

          return  createPermission(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePermissionMutationResult = NonNullable<Awaited<ReturnType<typeof createPermission>>>
    export type CreatePermissionMutationBody = CreatePermissionDto
    export type CreatePermissionMutationError = unknown

    /**
 * @summary ساخت دسترسی جدید
 */
export const useCreatePermission = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermission>>, TError,{data: CreatePermissionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPermission>>,
        TError,
        {data: CreatePermissionDto},
        TContext
      > => {
      return useMutation(getCreatePermissionMutationOptions(options), queryClient);
    }

/**
 * @summary لیست دسترسی‌ها
 */
export type getPermissionsResponse200 = {
  data: ResponsePermissionArrayDto
  status: 200
}

export type getPermissionsResponseSuccess = (getPermissionsResponse200) & {
  headers: Headers;
};
;

export type getPermissionsResponse = (getPermissionsResponseSuccess)

export const getGetPermissionsUrl = (params?: GetPermissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/permissions?${stringifiedParams}` : `/permissions`
}

export const getPermissions = async (params?: GetPermissionsParams, options?: RequestInit): Promise<getPermissionsResponse> => {

  return customInstance<getPermissionsResponse>(getGetPermissionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPermissionsQueryKey = (params?: GetPermissionsParams,) => {
    return [
    `/permissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getPermissions>>, TError = unknown>(params?: GetPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissions>>> = ({ signal }) => getPermissions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissions>>>
export type GetPermissionsQueryError = unknown


export function useGetPermissions<TData = Awaited<ReturnType<typeof getPermissions>>, TError = unknown>(
 params: undefined |  GetPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissions>>,
          TError,
          Awaited<ReturnType<typeof getPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissions<TData = Awaited<ReturnType<typeof getPermissions>>, TError = unknown>(
 params?: GetPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissions>>,
          TError,
          Awaited<ReturnType<typeof getPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissions<TData = Awaited<ReturnType<typeof getPermissions>>, TError = unknown>(
 params?: GetPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست دسترسی‌ها
 */

export function useGetPermissions<TData = Awaited<ReturnType<typeof getPermissions>>, TError = unknown>(
 params?: GetPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPermissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary اطلاعات یک دسترسی
 */
export type getPermissionResponse200 = {
  data: ResponsePermissionDto
  status: 200
}

export type getPermissionResponseSuccess = (getPermissionResponse200) & {
  headers: Headers;
};
;

export type getPermissionResponse = (getPermissionResponseSuccess)

export const getGetPermissionUrl = (id: number,) => {




  return `/permissions/${id}`
}

export const getPermission = async (id: number, options?: RequestInit): Promise<getPermissionResponse> => {

  return customInstance<getPermissionResponse>(getGetPermissionUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPermissionQueryKey = (id: number,) => {
    return [
    `/permissions/${id}`
    ] as const;
    }


export const getGetPermissionQueryOptions = <TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermission>>> = ({ signal }) => getPermission(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof getPermission>>>
export type GetPermissionQueryError = unknown


export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermission>>,
          TError,
          Awaited<ReturnType<typeof getPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermission>>,
          TError,
          Awaited<ReturnType<typeof getPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary اطلاعات یک دسترسی
 */

export function useGetPermission<TData = Awaited<ReturnType<typeof getPermission>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermission>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPermissionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ویرایش دسترسی
 */
export type updatePermissionResponse200 = {
  data: ResponsePermissionDto
  status: 200
}

export type updatePermissionResponseSuccess = (updatePermissionResponse200) & {
  headers: Headers;
};
;

export type updatePermissionResponse = (updatePermissionResponseSuccess)

export const getUpdatePermissionUrl = (id: number,) => {




  return `/permissions/${id}`
}

export const updatePermission = async (id: number,
    updatePermissionDto: UpdatePermissionDto, options?: RequestInit): Promise<updatePermissionResponse> => {

  return customInstance<updatePermissionResponse>(getUpdatePermissionUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updatePermissionDto,)
  }
);}




export const getUpdatePermissionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePermission>>, TError,{id: number;data: UpdatePermissionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePermission>>, TError,{id: number;data: UpdatePermissionDto}, TContext> => {

const mutationKey = ['updatePermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePermission>>, {id: number;data: UpdatePermissionDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePermission(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePermissionMutationResult = NonNullable<Awaited<ReturnType<typeof updatePermission>>>
    export type UpdatePermissionMutationBody = UpdatePermissionDto
    export type UpdatePermissionMutationError = unknown

    /**
 * @summary ویرایش دسترسی
 */
export const useUpdatePermission = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePermission>>, TError,{id: number;data: UpdatePermissionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePermission>>,
        TError,
        {id: number;data: UpdatePermissionDto},
        TContext
      > => {
      return useMutation(getUpdatePermissionMutationOptions(options), queryClient);
    }

/**
 * @summary حذف دسترسی
 */
export type deletePermissionResponse200 = {
  data: ResponsePermissionDto
  status: 200
}

export type deletePermissionResponseSuccess = (deletePermissionResponse200) & {
  headers: Headers;
};
;

export type deletePermissionResponse = (deletePermissionResponseSuccess)

export const getDeletePermissionUrl = (id: number,) => {




  return `/permissions/${id}`
}

export const deletePermission = async (id: number, options?: RequestInit): Promise<deletePermissionResponse> => {

  return customInstance<deletePermissionResponse>(getDeletePermissionUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePermissionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermission>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePermission>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePermission>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePermission(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePermissionMutationResult = NonNullable<Awaited<ReturnType<typeof deletePermission>>>

    export type DeletePermissionMutationError = unknown

    /**
 * @summary حذف دسترسی
 */
export const useDeletePermission = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermission>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePermission>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePermissionMutationOptions(options), queryClient);
    }

/**
 * @summary Upload file
 */
export type uploadFileResponse201 = {
  data: UploadResponseDto
  status: 201
}

export type uploadFileResponseSuccess = (uploadFileResponse201) & {
  headers: Headers;
};
;

export type uploadFileResponse = (uploadFileResponseSuccess)

export const getUploadFileUrl = () => {




  return `/upload/file`
}

export const uploadFile = async (uploadFileDto: UploadFileDto, options?: RequestInit): Promise<uploadFileResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadFileDto.file);

  return customInstance<uploadFileResponse>(getUploadFileUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}




export const getUploadFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{data: UploadFileDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{data: UploadFileDto}, TContext> => {

const mutationKey = ['uploadFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadFile>>, {data: UploadFileDto}> = (props) => {
          const {data} = props ?? {};

          return  uploadFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadFile>>>
    export type UploadFileMutationBody = UploadFileDto
    export type UploadFileMutationError = unknown

    /**
 * @summary Upload file
 */
export const useUploadFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{data: UploadFileDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadFile>>,
        TError,
        {data: UploadFileDto},
        TContext
      > => {
      return useMutation(getUploadFileMutationOptions(options), queryClient);
    }

/**
 * @summary Upload image
 */
export type uploadImageResponse201 = {
  data: UploadResponseDto
  status: 201
}

export type uploadImageResponseSuccess = (uploadImageResponse201) & {
  headers: Headers;
};
;

export type uploadImageResponse = (uploadImageResponseSuccess)

export const getUploadImageUrl = () => {




  return `/upload/image`
}

export const uploadImage = async (uploadImageBody: UploadImageBody, options?: RequestInit): Promise<uploadImageResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadImageBody.file);
if(uploadImageBody.resize !== undefined) {
 formData.append(`resize`, uploadImageBody.resize.toString())
 }

  return customInstance<uploadImageResponse>(getUploadImageUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body:
      formData,
  }
);}




export const getUploadImageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext> => {

const mutationKey = ['uploadImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImage>>, {data: UploadImageBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImage>>>
    export type UploadImageMutationBody = UploadImageBody
    export type UploadImageMutationError = unknown

    /**
 * @summary Upload image
 */
export const useUploadImage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadImage>>,
        TError,
        {data: UploadImageBody},
        TContext
      > => {
      return useMutation(getUploadImageMutationOptions(options), queryClient);
    }

/**
 * @summary ساخت فروشگاه جدید
 */
export type createStoreResponse201 = {
  data: ResponseStoreDto
  status: 201
}

export type createStoreResponseSuccess = (createStoreResponse201) & {
  headers: Headers;
};
;

export type createStoreResponse = (createStoreResponseSuccess)

export const getCreateStoreUrl = () => {




  return `/stores`
}

export const createStore = async (createStoreDto: CreateStoreDto, options?: RequestInit): Promise<createStoreResponse> => {

  return customInstance<createStoreResponse>(getCreateStoreUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createStoreDto,)
  }
);}




export const getCreateStoreMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStore>>, TError,{data: CreateStoreDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createStore>>, TError,{data: CreateStoreDto}, TContext> => {

const mutationKey = ['createStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStore>>, {data: CreateStoreDto}> = (props) => {
          const {data} = props ?? {};

          return  createStore(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStoreMutationResult = NonNullable<Awaited<ReturnType<typeof createStore>>>
    export type CreateStoreMutationBody = CreateStoreDto
    export type CreateStoreMutationError = unknown

    /**
 * @summary ساخت فروشگاه جدید
 */
export const useCreateStore = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStore>>, TError,{data: CreateStoreDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStore>>,
        TError,
        {data: CreateStoreDto},
        TContext
      > => {
      return useMutation(getCreateStoreMutationOptions(options), queryClient);
    }

/**
 * @summary لیست فروشگاه‌ها
 */
export type getStoresResponse200 = {
  data: ResponseStoreArrayDto
  status: 200
}

export type getStoresResponseSuccess = (getStoresResponse200) & {
  headers: Headers;
};
;

export type getStoresResponse = (getStoresResponseSuccess)

export const getGetStoresUrl = (params?: GetStoresParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/stores?${stringifiedParams}` : `/stores`
}

export const getStores = async (params?: GetStoresParams, options?: RequestInit): Promise<getStoresResponse> => {

  return customInstance<getStoresResponse>(getGetStoresUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoresQueryKey = (params?: GetStoresParams,) => {
    return [
    `/stores`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStoresQueryOptions = <TData = Awaited<ReturnType<typeof getStores>>, TError = unknown>(params?: GetStoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoresQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStores>>> = ({ signal }) => getStores(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoresQueryResult = NonNullable<Awaited<ReturnType<typeof getStores>>>
export type GetStoresQueryError = unknown


export function useGetStores<TData = Awaited<ReturnType<typeof getStores>>, TError = unknown>(
 params: undefined |  GetStoresParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStores>>,
          TError,
          Awaited<ReturnType<typeof getStores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStores<TData = Awaited<ReturnType<typeof getStores>>, TError = unknown>(
 params?: GetStoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStores>>,
          TError,
          Awaited<ReturnType<typeof getStores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStores<TData = Awaited<ReturnType<typeof getStores>>, TError = unknown>(
 params?: GetStoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست فروشگاه‌ها
 */

export function useGetStores<TData = Awaited<ReturnType<typeof getStores>>, TError = unknown>(
 params?: GetStoresParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoresQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary گرفتن اطلاعات فروشگاه
 */
export type getStoreResponse200 = {
  data: ResponseStoreDto
  status: 200
}

export type getStoreResponseSuccess = (getStoreResponse200) & {
  headers: Headers;
};
;

export type getStoreResponse = (getStoreResponseSuccess)

export const getGetStoreUrl = (id: number,) => {




  return `/stores/${id}`
}

export const getStore = async (id: number, options?: RequestInit): Promise<getStoreResponse> => {

  return customInstance<getStoreResponse>(getGetStoreUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreQueryKey = (id: number,) => {
    return [
    `/stores/${id}`
    ] as const;
    }


export const getGetStoreQueryOptions = <TData = Awaited<ReturnType<typeof getStore>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStore>>> = ({ signal }) => getStore(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoreQueryResult = NonNullable<Awaited<ReturnType<typeof getStore>>>
export type GetStoreQueryError = unknown


export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStore>>,
          TError,
          Awaited<ReturnType<typeof getStore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStore>>,
          TError,
          Awaited<ReturnType<typeof getStore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گرفتن اطلاعات فروشگاه
 */

export function useGetStore<TData = Awaited<ReturnType<typeof getStore>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoreQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary به‌روزرسانی فروشگاه
 */
export type updateStoreResponse200 = {
  data: ResponseStoreDto
  status: 200
}

export type updateStoreResponseSuccess = (updateStoreResponse200) & {
  headers: Headers;
};
;

export type updateStoreResponse = (updateStoreResponseSuccess)

export const getUpdateStoreUrl = (id: number,) => {




  return `/stores/${id}`
}

export const updateStore = async (id: number,
    updateStoreDto: UpdateStoreDto, options?: RequestInit): Promise<updateStoreResponse> => {

  return customInstance<updateStoreResponse>(getUpdateStoreUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateStoreDto,)
  }
);}




export const getUpdateStoreMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStore>>, TError,{id: number;data: UpdateStoreDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStore>>, TError,{id: number;data: UpdateStoreDto}, TContext> => {

const mutationKey = ['updateStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStore>>, {id: number;data: UpdateStoreDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateStore(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoreMutationResult = NonNullable<Awaited<ReturnType<typeof updateStore>>>
    export type UpdateStoreMutationBody = UpdateStoreDto
    export type UpdateStoreMutationError = unknown

    /**
 * @summary به‌روزرسانی فروشگاه
 */
export const useUpdateStore = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStore>>, TError,{id: number;data: UpdateStoreDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStore>>,
        TError,
        {id: number;data: UpdateStoreDto},
        TContext
      > => {
      return useMutation(getUpdateStoreMutationOptions(options), queryClient);
    }

/**
 * @summary حذف فروشگاه
 */
export type deleteStoreResponse200 = {
  data: ResponseStoreDto
  status: 200
}

export type deleteStoreResponseSuccess = (deleteStoreResponse200) & {
  headers: Headers;
};
;

export type deleteStoreResponse = (deleteStoreResponseSuccess)

export const getDeleteStoreUrl = (id: number,) => {




  return `/stores/${id}`
}

export const deleteStore = async (id: number, options?: RequestInit): Promise<deleteStoreResponse> => {

  return customInstance<deleteStoreResponse>(getDeleteStoreUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteStoreMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStore>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStore>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteStore(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStoreMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStore>>>

    export type DeleteStoreMutationError = unknown

    /**
 * @summary حذف فروشگاه
 */
export const useDeleteStore = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStore>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteStoreMutationOptions(options), queryClient);
    }

/**
 * @summary غیرفعال‌سازی فروشگاه
 */
export type deactivateStoreResponse200 = {
  data: ResponseStoreDto
  status: 200
}

export type deactivateStoreResponseSuccess = (deactivateStoreResponse200) & {
  headers: Headers;
};
;

export type deactivateStoreResponse = (deactivateStoreResponseSuccess)

export const getDeactivateStoreUrl = (id: number,) => {




  return `/stores/${id}/deactivate`
}

export const deactivateStore = async (id: number, options?: RequestInit): Promise<deactivateStoreResponse> => {

  return customInstance<deactivateStoreResponse>(getDeactivateStoreUrl(id),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getDeactivateStoreMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateStore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateStore>>, TError,{id: number}, TContext> => {

const mutationKey = ['deactivateStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateStore>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deactivateStore(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeactivateStoreMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateStore>>>

    export type DeactivateStoreMutationError = unknown

    /**
 * @summary غیرفعال‌سازی فروشگاه
 */
export const useDeactivateStore = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateStore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateStore>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeactivateStoreMutationOptions(options), queryClient);
    }

/**
 * @summary فعال‌سازی دوباره فروشگاه
 */
export type activateStoreResponse200 = {
  data: ResponseStoreDto
  status: 200
}

export type activateStoreResponseSuccess = (activateStoreResponse200) & {
  headers: Headers;
};
;

export type activateStoreResponse = (activateStoreResponseSuccess)

export const getActivateStoreUrl = (id: number,) => {




  return `/stores/${id}/activate`
}

export const activateStore = async (id: number, options?: RequestInit): Promise<activateStoreResponse> => {

  return customInstance<activateStoreResponse>(getActivateStoreUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getActivateStoreMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateStore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activateStore>>, TError,{id: number}, TContext> => {

const mutationKey = ['activateStore'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateStore>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  activateStore(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivateStoreMutationResult = NonNullable<Awaited<ReturnType<typeof activateStore>>>

    export type ActivateStoreMutationError = unknown

    /**
 * @summary فعال‌سازی دوباره فروشگاه
 */
export const useActivateStore = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateStore>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateStore>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getActivateStoreMutationOptions(options), queryClient);
    }

/**
 * @summary لغو درخواست حذف فروشگاه
 */
export type cancelStoreDeleteResponse200 = {
  data: ResponseStoreDto
  status: 200
}

export type cancelStoreDeleteResponseSuccess = (cancelStoreDeleteResponse200) & {
  headers: Headers;
};
;

export type cancelStoreDeleteResponse = (cancelStoreDeleteResponseSuccess)

export const getCancelStoreDeleteUrl = (id: number,) => {




  return `/stores/${id}/schedule-delete`
}

export const cancelStoreDelete = async (id: number, options?: RequestInit): Promise<cancelStoreDeleteResponse> => {

  return customInstance<cancelStoreDeleteResponse>(getCancelStoreDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getCancelStoreDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelStoreDelete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelStoreDelete>>, TError,{id: number}, TContext> => {

const mutationKey = ['cancelStoreDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelStoreDelete>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  cancelStoreDelete(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelStoreDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof cancelStoreDelete>>>

    export type CancelStoreDeleteMutationError = unknown

    /**
 * @summary لغو درخواست حذف فروشگاه
 */
export const useCancelStoreDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelStoreDelete>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelStoreDelete>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getCancelStoreDeleteMutationOptions(options), queryClient);
    }

/**
 * @summary زمان‌بندی حذف فروشگاه
 */
export type scheduleStoreDeleteResponse200 = {
  data: ResponseStoreDto
  status: 200
}

export type scheduleStoreDeleteResponseSuccess = (scheduleStoreDeleteResponse200) & {
  headers: Headers;
};
;

export type scheduleStoreDeleteResponse = (scheduleStoreDeleteResponseSuccess)

export const getScheduleStoreDeleteUrl = (id: number,) => {




  return `/stores/${id}/schedule-delete`
}

export const scheduleStoreDelete = async (id: number,
    scheduleStoreDeleteDto: ScheduleStoreDeleteDto, options?: RequestInit): Promise<scheduleStoreDeleteResponse> => {

  return customInstance<scheduleStoreDeleteResponse>(getScheduleStoreDeleteUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      scheduleStoreDeleteDto,)
  }
);}




export const getScheduleStoreDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleStoreDelete>>, TError,{id: number;data: ScheduleStoreDeleteDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof scheduleStoreDelete>>, TError,{id: number;data: ScheduleStoreDeleteDto}, TContext> => {

const mutationKey = ['scheduleStoreDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scheduleStoreDelete>>, {id: number;data: ScheduleStoreDeleteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  scheduleStoreDelete(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ScheduleStoreDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof scheduleStoreDelete>>>
    export type ScheduleStoreDeleteMutationBody = ScheduleStoreDeleteDto
    export type ScheduleStoreDeleteMutationError = unknown

    /**
 * @summary زمان‌بندی حذف فروشگاه
 */
export const useScheduleStoreDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scheduleStoreDelete>>, TError,{id: number;data: ScheduleStoreDeleteDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scheduleStoreDelete>>,
        TError,
        {id: number;data: ScheduleStoreDeleteDto},
        TContext
      > => {
      return useMutation(getScheduleStoreDeleteMutationOptions(options), queryClient);
    }

/**
 * @summary نرخ کارمزد و سقف بدهی
 */
export type getBillingConfigResponse200 = {
  data: ResponseBillingConfigDto
  status: 200
}

export type getBillingConfigResponseSuccess = (getBillingConfigResponse200) & {
  headers: Headers;
};
;

export type getBillingConfigResponse = (getBillingConfigResponseSuccess)

export const getGetBillingConfigUrl = () => {




  return `/billing/config`
}

export const getBillingConfig = async ( options?: RequestInit): Promise<getBillingConfigResponse> => {

  return customInstance<getBillingConfigResponse>(getGetBillingConfigUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingConfigQueryKey = () => {
    return [
    `/billing/config`
    ] as const;
    }


export const getGetBillingConfigQueryOptions = <TData = Awaited<ReturnType<typeof getBillingConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingConfig>>> = ({ signal }) => getBillingConfig({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingConfig>>>
export type GetBillingConfigQueryError = unknown


export function useGetBillingConfig<TData = Awaited<ReturnType<typeof getBillingConfig>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingConfig>>,
          TError,
          Awaited<ReturnType<typeof getBillingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingConfig<TData = Awaited<ReturnType<typeof getBillingConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingConfig>>,
          TError,
          Awaited<ReturnType<typeof getBillingConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingConfig<TData = Awaited<ReturnType<typeof getBillingConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary نرخ کارمزد و سقف بدهی
 */

export function useGetBillingConfig<TData = Awaited<ReturnType<typeof getBillingConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary خلاصه کارمزد
 */
export type getBillingSummaryResponse200 = {
  data: ResponseBillingSummaryDto
  status: 200
}

export type getBillingSummaryResponseSuccess = (getBillingSummaryResponse200) & {
  headers: Headers;
};
;

export type getBillingSummaryResponse = (getBillingSummaryResponseSuccess)

export const getGetBillingSummaryUrl = () => {




  return `/billing/summary`
}

export const getBillingSummary = async ( options?: RequestInit): Promise<getBillingSummaryResponse> => {

  return customInstance<getBillingSummaryResponse>(getGetBillingSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingSummaryQueryKey = () => {
    return [
    `/billing/summary`
    ] as const;
    }


export const getGetBillingSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingSummary>>> = ({ signal }) => getBillingSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingSummary>>>
export type GetBillingSummaryQueryError = unknown


export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingSummary>>,
          TError,
          Awaited<ReturnType<typeof getBillingSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingSummary>>,
          TError,
          Awaited<ReturnType<typeof getBillingSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary خلاصه کارمزد
 */

export function useGetBillingSummary<TData = Awaited<ReturnType<typeof getBillingSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary وضعیت کارمزد و بدهی فروشگاه‌ها
 */
export type getBillingShopsResponse200 = {
  data: ResponseBillingShopsDto
  status: 200
}

export type getBillingShopsResponseSuccess = (getBillingShopsResponse200) & {
  headers: Headers;
};
;

export type getBillingShopsResponse = (getBillingShopsResponseSuccess)

export const getGetBillingShopsUrl = () => {




  return `/billing/shops`
}

export const getBillingShops = async ( options?: RequestInit): Promise<getBillingShopsResponse> => {

  return customInstance<getBillingShopsResponse>(getGetBillingShopsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingShopsQueryKey = () => {
    return [
    `/billing/shops`
    ] as const;
    }


export const getGetBillingShopsQueryOptions = <TData = Awaited<ReturnType<typeof getBillingShops>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingShops>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingShopsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingShops>>> = ({ signal }) => getBillingShops({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingShops>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingShopsQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingShops>>>
export type GetBillingShopsQueryError = unknown


export function useGetBillingShops<TData = Awaited<ReturnType<typeof getBillingShops>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingShops>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingShops>>,
          TError,
          Awaited<ReturnType<typeof getBillingShops>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingShops<TData = Awaited<ReturnType<typeof getBillingShops>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingShops>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingShops>>,
          TError,
          Awaited<ReturnType<typeof getBillingShops>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingShops<TData = Awaited<ReturnType<typeof getBillingShops>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingShops>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت کارمزد و بدهی فروشگاه‌ها
 */

export function useGetBillingShops<TData = Awaited<ReturnType<typeof getBillingShops>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingShops>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingShopsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ریز کارمزد سفارش‌ها
 */
export type getCommissionsResponse200 = {
  data: ResponseCommissionsDto
  status: 200
}

export type getCommissionsResponseSuccess = (getCommissionsResponse200) & {
  headers: Headers;
};
;

export type getCommissionsResponse = (getCommissionsResponseSuccess)

export const getGetCommissionsUrl = (params?: GetCommissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/billing/commissions?${stringifiedParams}` : `/billing/commissions`
}

export const getCommissions = async (params?: GetCommissionsParams, options?: RequestInit): Promise<getCommissionsResponse> => {

  return customInstance<getCommissionsResponse>(getGetCommissionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCommissionsQueryKey = (params?: GetCommissionsParams,) => {
    return [
    `/billing/commissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCommissionsQueryOptions = <TData = Awaited<ReturnType<typeof getCommissions>>, TError = unknown>(params?: GetCommissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissions>>> = ({ signal }) => getCommissions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissions>>>
export type GetCommissionsQueryError = unknown


export function useGetCommissions<TData = Awaited<ReturnType<typeof getCommissions>>, TError = unknown>(
 params: undefined |  GetCommissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissions>>,
          TError,
          Awaited<ReturnType<typeof getCommissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissions<TData = Awaited<ReturnType<typeof getCommissions>>, TError = unknown>(
 params?: GetCommissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissions>>,
          TError,
          Awaited<ReturnType<typeof getCommissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissions<TData = Awaited<ReturnType<typeof getCommissions>>, TError = unknown>(
 params?: GetCommissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ریز کارمزد سفارش‌ها
 */

export function useGetCommissions<TData = Awaited<ReturnType<typeof getCommissions>>, TError = unknown>(
 params?: GetCommissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary تاریخچه پرداخت بدهی کارمزد
 */
export type getBillingInvoicesResponse200 = {
  data: ResponseBillingInvoicesDto
  status: 200
}

export type getBillingInvoicesResponseSuccess = (getBillingInvoicesResponse200) & {
  headers: Headers;
};
;

export type getBillingInvoicesResponse = (getBillingInvoicesResponseSuccess)

export const getGetBillingInvoicesUrl = (params?: GetBillingInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/billing/invoices?${stringifiedParams}` : `/billing/invoices`
}

export const getBillingInvoices = async (params?: GetBillingInvoicesParams, options?: RequestInit): Promise<getBillingInvoicesResponse> => {

  return customInstance<getBillingInvoicesResponse>(getGetBillingInvoicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBillingInvoicesQueryKey = (params?: GetBillingInvoicesParams,) => {
    return [
    `/billing/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetBillingInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getBillingInvoices>>, TError = unknown>(params?: GetBillingInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingInvoices>>> = ({ signal }) => getBillingInvoices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getBillingInvoices>>>
export type GetBillingInvoicesQueryError = unknown


export function useGetBillingInvoices<TData = Awaited<ReturnType<typeof getBillingInvoices>>, TError = unknown>(
 params: undefined |  GetBillingInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingInvoices>>,
          TError,
          Awaited<ReturnType<typeof getBillingInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingInvoices<TData = Awaited<ReturnType<typeof getBillingInvoices>>, TError = unknown>(
 params?: GetBillingInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingInvoices>>,
          TError,
          Awaited<ReturnType<typeof getBillingInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingInvoices<TData = Awaited<ReturnType<typeof getBillingInvoices>>, TError = unknown>(
 params?: GetBillingInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تاریخچه پرداخت بدهی کارمزد
 */

export function useGetBillingInvoices<TData = Awaited<ReturnType<typeof getBillingInvoices>>, TError = unknown>(
 params?: GetBillingInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBillingInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBillingInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary پرداخت آنلاین بدهی کارمزد
 */
export type payCommissionDebtResponse200 = {
  data: ResponseBillingPayDto
  status: 200
}

export type payCommissionDebtResponseSuccess = (payCommissionDebtResponse200) & {
  headers: Headers;
};
;

export type payCommissionDebtResponse = (payCommissionDebtResponseSuccess)

export const getPayCommissionDebtUrl = (storeId: number,) => {




  return `/billing/shops/${storeId}/pay-debt`
}

export const payCommissionDebt = async (storeId: number, options?: RequestInit): Promise<payCommissionDebtResponse> => {

  return customInstance<payCommissionDebtResponse>(getPayCommissionDebtUrl(storeId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPayCommissionDebtMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payCommissionDebt>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof payCommissionDebt>>, TError,{storeId: number}, TContext> => {

const mutationKey = ['payCommissionDebt'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payCommissionDebt>>, {storeId: number}> = (props) => {
          const {storeId} = props ?? {};

          return  payCommissionDebt(storeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PayCommissionDebtMutationResult = NonNullable<Awaited<ReturnType<typeof payCommissionDebt>>>

    export type PayCommissionDebtMutationError = unknown

    /**
 * @summary پرداخت آنلاین بدهی کارمزد
 */
export const usePayCommissionDebt = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payCommissionDebt>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payCommissionDebt>>,
        TError,
        {storeId: number},
        TContext
      > => {
      return useMutation(getPayCommissionDebtMutationOptions(options), queryClient);
    }

/**
 * @summary ساخت شبکه اجتماعی جدید
 */
export type createSocialNetworkResponse201 = {
  data: ResponseSocialNetworkDto
  status: 201
}

export type createSocialNetworkResponseSuccess = (createSocialNetworkResponse201) & {
  headers: Headers;
};
;

export type createSocialNetworkResponse = (createSocialNetworkResponseSuccess)

export const getCreateSocialNetworkUrl = () => {




  return `/social-networks`
}

export const createSocialNetwork = async (createSocialNetworkDto: CreateSocialNetworkDto, options?: RequestInit): Promise<createSocialNetworkResponse> => {

  return customInstance<createSocialNetworkResponse>(getCreateSocialNetworkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSocialNetworkDto,)
  }
);}




export const getCreateSocialNetworkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialNetwork>>, TError,{data: CreateSocialNetworkDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSocialNetwork>>, TError,{data: CreateSocialNetworkDto}, TContext> => {

const mutationKey = ['createSocialNetwork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSocialNetwork>>, {data: CreateSocialNetworkDto}> = (props) => {
          const {data} = props ?? {};

          return  createSocialNetwork(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSocialNetworkMutationResult = NonNullable<Awaited<ReturnType<typeof createSocialNetwork>>>
    export type CreateSocialNetworkMutationBody = CreateSocialNetworkDto
    export type CreateSocialNetworkMutationError = unknown

    /**
 * @summary ساخت شبکه اجتماعی جدید
 */
export const useCreateSocialNetwork = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSocialNetwork>>, TError,{data: CreateSocialNetworkDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSocialNetwork>>,
        TError,
        {data: CreateSocialNetworkDto},
        TContext
      > => {
      return useMutation(getCreateSocialNetworkMutationOptions(options), queryClient);
    }

/**
 * @summary لیست شبکه‌های اجتماعی
 */
export type getSocialNetworksResponse200 = {
  data: ResponseSocialNetworkArrayDto
  status: 200
}

export type getSocialNetworksResponseSuccess = (getSocialNetworksResponse200) & {
  headers: Headers;
};
;

export type getSocialNetworksResponse = (getSocialNetworksResponseSuccess)

export const getGetSocialNetworksUrl = (params?: GetSocialNetworksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/social-networks?${stringifiedParams}` : `/social-networks`
}

export const getSocialNetworks = async (params?: GetSocialNetworksParams, options?: RequestInit): Promise<getSocialNetworksResponse> => {

  return customInstance<getSocialNetworksResponse>(getGetSocialNetworksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialNetworksQueryKey = (params?: GetSocialNetworksParams,) => {
    return [
    `/social-networks`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSocialNetworksQueryOptions = <TData = Awaited<ReturnType<typeof getSocialNetworks>>, TError = unknown>(params?: GetSocialNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetworks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialNetworksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialNetworks>>> = ({ signal }) => getSocialNetworks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialNetworks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSocialNetworksQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialNetworks>>>
export type GetSocialNetworksQueryError = unknown


export function useGetSocialNetworks<TData = Awaited<ReturnType<typeof getSocialNetworks>>, TError = unknown>(
 params: undefined |  GetSocialNetworksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetworks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSocialNetworks>>,
          TError,
          Awaited<ReturnType<typeof getSocialNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSocialNetworks<TData = Awaited<ReturnType<typeof getSocialNetworks>>, TError = unknown>(
 params?: GetSocialNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetworks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSocialNetworks>>,
          TError,
          Awaited<ReturnType<typeof getSocialNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSocialNetworks<TData = Awaited<ReturnType<typeof getSocialNetworks>>, TError = unknown>(
 params?: GetSocialNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetworks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست شبکه‌های اجتماعی
 */

export function useGetSocialNetworks<TData = Awaited<ReturnType<typeof getSocialNetworks>>, TError = unknown>(
 params?: GetSocialNetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetworks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSocialNetworksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary لیست شبکه‌های اجتماعی یک فروشگاه خاص
 */
export type getStoreSocialNetworksResponse200 = {
  data: ResponseSocialNetworkArrayDto
  status: 200
}

export type getStoreSocialNetworksResponseSuccess = (getStoreSocialNetworksResponse200) & {
  headers: Headers;
};
;

export type getStoreSocialNetworksResponse = (getStoreSocialNetworksResponseSuccess)

export const getGetStoreSocialNetworksUrl = (storeId: number,) => {




  return `/social-networks/by-store/${storeId}`
}

export const getStoreSocialNetworks = async (storeId: number, options?: RequestInit): Promise<getStoreSocialNetworksResponse> => {

  return customInstance<getStoreSocialNetworksResponse>(getGetStoreSocialNetworksUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreSocialNetworksQueryKey = (storeId: number,) => {
    return [
    `/social-networks/by-store/${storeId}`
    ] as const;
    }


export const getGetStoreSocialNetworksQueryOptions = <TData = Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError = unknown>(storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreSocialNetworksQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreSocialNetworks>>> = ({ signal }) => getStoreSocialNetworks(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(storeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoreSocialNetworksQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreSocialNetworks>>>
export type GetStoreSocialNetworksQueryError = unknown


export function useGetStoreSocialNetworks<TData = Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError = unknown>(
 storeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreSocialNetworks>>,
          TError,
          Awaited<ReturnType<typeof getStoreSocialNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreSocialNetworks<TData = Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreSocialNetworks>>,
          TError,
          Awaited<ReturnType<typeof getStoreSocialNetworks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreSocialNetworks<TData = Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست شبکه‌های اجتماعی یک فروشگاه خاص
 */

export function useGetStoreSocialNetworks<TData = Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSocialNetworks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoreSocialNetworksQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary گرفتن اطلاعات شبکه اجتماعی
 */
export type getSocialNetworkResponse200 = {
  data: ResponseSocialNetworkDto
  status: 200
}

export type getSocialNetworkResponseSuccess = (getSocialNetworkResponse200) & {
  headers: Headers;
};
;

export type getSocialNetworkResponse = (getSocialNetworkResponseSuccess)

export const getGetSocialNetworkUrl = (id: number,) => {




  return `/social-networks/${id}`
}

export const getSocialNetwork = async (id: number, options?: RequestInit): Promise<getSocialNetworkResponse> => {

  return customInstance<getSocialNetworkResponse>(getGetSocialNetworkUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSocialNetworkQueryKey = (id: number,) => {
    return [
    `/social-networks/${id}`
    ] as const;
    }


export const getGetSocialNetworkQueryOptions = <TData = Awaited<ReturnType<typeof getSocialNetwork>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialNetworkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialNetwork>>> = ({ signal }) => getSocialNetwork(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialNetwork>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSocialNetworkQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialNetwork>>>
export type GetSocialNetworkQueryError = unknown


export function useGetSocialNetwork<TData = Awaited<ReturnType<typeof getSocialNetwork>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetwork>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSocialNetwork>>,
          TError,
          Awaited<ReturnType<typeof getSocialNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSocialNetwork<TData = Awaited<ReturnType<typeof getSocialNetwork>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetwork>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSocialNetwork>>,
          TError,
          Awaited<ReturnType<typeof getSocialNetwork>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSocialNetwork<TData = Awaited<ReturnType<typeof getSocialNetwork>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گرفتن اطلاعات شبکه اجتماعی
 */

export function useGetSocialNetwork<TData = Awaited<ReturnType<typeof getSocialNetwork>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialNetwork>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSocialNetworkQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary به‌روزرسانی شبکه اجتماعی
 */
export type updateSocialNetworkResponse200 = {
  data: ResponseSocialNetworkDto
  status: 200
}

export type updateSocialNetworkResponseSuccess = (updateSocialNetworkResponse200) & {
  headers: Headers;
};
;

export type updateSocialNetworkResponse = (updateSocialNetworkResponseSuccess)

export const getUpdateSocialNetworkUrl = (id: number,) => {




  return `/social-networks/${id}`
}

export const updateSocialNetwork = async (id: number,
    updateSocialNetworkDto: UpdateSocialNetworkDto, options?: RequestInit): Promise<updateSocialNetworkResponse> => {

  return customInstance<updateSocialNetworkResponse>(getUpdateSocialNetworkUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSocialNetworkDto,)
  }
);}




export const getUpdateSocialNetworkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialNetwork>>, TError,{id: number;data: UpdateSocialNetworkDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialNetwork>>, TError,{id: number;data: UpdateSocialNetworkDto}, TContext> => {

const mutationKey = ['updateSocialNetwork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialNetwork>>, {id: number;data: UpdateSocialNetworkDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateSocialNetwork(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialNetworkMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialNetwork>>>
    export type UpdateSocialNetworkMutationBody = UpdateSocialNetworkDto
    export type UpdateSocialNetworkMutationError = unknown

    /**
 * @summary به‌روزرسانی شبکه اجتماعی
 */
export const useUpdateSocialNetwork = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialNetwork>>, TError,{id: number;data: UpdateSocialNetworkDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialNetwork>>,
        TError,
        {id: number;data: UpdateSocialNetworkDto},
        TContext
      > => {
      return useMutation(getUpdateSocialNetworkMutationOptions(options), queryClient);
    }

/**
 * @summary حذف شبکه اجتماعی
 */
export type deleteSocialNetworkResponse200 = {
  data: ResponseSocialNetworkDto
  status: 200
}

export type deleteSocialNetworkResponseSuccess = (deleteSocialNetworkResponse200) & {
  headers: Headers;
};
;

export type deleteSocialNetworkResponse = (deleteSocialNetworkResponseSuccess)

export const getDeleteSocialNetworkUrl = (id: number,) => {




  return `/social-networks/${id}`
}

export const deleteSocialNetwork = async (id: number, options?: RequestInit): Promise<deleteSocialNetworkResponse> => {

  return customInstance<deleteSocialNetworkResponse>(getDeleteSocialNetworkUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteSocialNetworkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialNetwork>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSocialNetwork>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteSocialNetwork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSocialNetwork>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteSocialNetwork(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSocialNetworkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSocialNetwork>>>

    export type DeleteSocialNetworkMutationError = unknown

    /**
 * @summary حذف شبکه اجتماعی
 */
export const useDeleteSocialNetwork = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSocialNetwork>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSocialNetwork>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteSocialNetworkMutationOptions(options), queryClient);
    }

/**
 * @summary ساخت مشتری جدید
 */
export type createCustomerResponse201 = {
  data: ResponseCustomerDto
  status: 201
}

export type createCustomerResponseSuccess = (createCustomerResponse201) & {
  headers: Headers;
};
;

export type createCustomerResponse = (createCustomerResponseSuccess)

export const getCreateCustomerUrl = () => {




  return `/customers`
}

export const createCustomer = async (createCustomerDto: CreateCustomerDto, options?: RequestInit): Promise<createCustomerResponse> => {

  return customInstance<createCustomerResponse>(getCreateCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createCustomerDto,)
  }
);}




export const getCreateCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: CreateCustomerDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: CreateCustomerDto}, TContext> => {

const mutationKey = ['createCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomer>>, {data: CreateCustomerDto}> = (props) => {
          const {data} = props ?? {};

          return  createCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomer>>>
    export type CreateCustomerMutationBody = CreateCustomerDto
    export type CreateCustomerMutationError = unknown

    /**
 * @summary ساخت مشتری جدید
 */
export const useCreateCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: CreateCustomerDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustomer>>,
        TError,
        {data: CreateCustomerDto},
        TContext
      > => {
      return useMutation(getCreateCustomerMutationOptions(options), queryClient);
    }

/**
 * @summary لیست مشتریان
 */
export type getCustomersResponse200 = {
  data: ResponseCustomerArrayDto
  status: 200
}

export type getCustomersResponseSuccess = (getCustomersResponse200) & {
  headers: Headers;
};
;

export type getCustomersResponse = (getCustomersResponseSuccess)

export const getGetCustomersUrl = (params?: GetCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/customers?${stringifiedParams}` : `/customers`
}

export const getCustomers = async (params?: GetCustomersParams, options?: RequestInit): Promise<getCustomersResponse> => {

  return customInstance<getCustomersResponse>(getGetCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomersQueryKey = (params?: GetCustomersParams,) => {
    return [
    `/customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomers>>> = ({ signal }) => getCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomers>>>
export type GetCustomersQueryError = unknown


export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params: undefined |  GetCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست مشتریان
 */

export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = unknown>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary آمار مشتریان
 */
export type getCustomerStatsResponse200 = {
  data: ResponseCustomerStatsDto
  status: 200
}

export type getCustomerStatsResponseSuccess = (getCustomerStatsResponse200) & {
  headers: Headers;
};
;

export type getCustomerStatsResponse = (getCustomerStatsResponseSuccess)

export const getGetCustomerStatsUrl = (params?: GetCustomerStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/customers/stats?${stringifiedParams}` : `/customers/stats`
}

export const getCustomerStats = async (params?: GetCustomerStatsParams, options?: RequestInit): Promise<getCustomerStatsResponse> => {

  return customInstance<getCustomerStatsResponse>(getGetCustomerStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerStatsQueryKey = (params?: GetCustomerStatsParams,) => {
    return [
    `/customers/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCustomerStatsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerStats>>, TError = unknown>(params?: GetCustomerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerStats>>> = ({ signal }) => getCustomerStats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerStats>>>
export type GetCustomerStatsQueryError = unknown


export function useGetCustomerStats<TData = Awaited<ReturnType<typeof getCustomerStats>>, TError = unknown>(
 params: undefined |  GetCustomerStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerStats>>,
          TError,
          Awaited<ReturnType<typeof getCustomerStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerStats<TData = Awaited<ReturnType<typeof getCustomerStats>>, TError = unknown>(
 params?: GetCustomerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerStats>>,
          TError,
          Awaited<ReturnType<typeof getCustomerStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerStats<TData = Awaited<ReturnType<typeof getCustomerStats>>, TError = unknown>(
 params?: GetCustomerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary آمار مشتریان
 */

export function useGetCustomerStats<TData = Awaited<ReturnType<typeof getCustomerStats>>, TError = unknown>(
 params?: GetCustomerStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary لیست مشتریان یک فروشگاه خاص
 */
export type getStoreCustomersResponse200 = {
  data: ResponseCustomerArrayDto
  status: 200
}

export type getStoreCustomersResponseSuccess = (getStoreCustomersResponse200) & {
  headers: Headers;
};
;

export type getStoreCustomersResponse = (getStoreCustomersResponseSuccess)

export const getGetStoreCustomersUrl = (storeId: number,) => {




  return `/customers/by-store/${storeId}`
}

export const getStoreCustomers = async (storeId: number, options?: RequestInit): Promise<getStoreCustomersResponse> => {

  return customInstance<getStoreCustomersResponse>(getGetStoreCustomersUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreCustomersQueryKey = (storeId: number,) => {
    return [
    `/customers/by-store/${storeId}`
    ] as const;
    }


export const getGetStoreCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getStoreCustomers>>, TError = unknown>(storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreCustomersQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreCustomers>>> = ({ signal }) => getStoreCustomers(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(storeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoreCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreCustomers>>>
export type GetStoreCustomersQueryError = unknown


export function useGetStoreCustomers<TData = Awaited<ReturnType<typeof getStoreCustomers>>, TError = unknown>(
 storeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreCustomers>>,
          TError,
          Awaited<ReturnType<typeof getStoreCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreCustomers<TData = Awaited<ReturnType<typeof getStoreCustomers>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreCustomers>>,
          TError,
          Awaited<ReturnType<typeof getStoreCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreCustomers<TData = Awaited<ReturnType<typeof getStoreCustomers>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست مشتریان یک فروشگاه خاص
 */

export function useGetStoreCustomers<TData = Awaited<ReturnType<typeof getStoreCustomers>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoreCustomersQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary گرفتن اطلاعات مشتری
 */
export type getCustomerResponse200 = {
  data: ResponseCustomerDto
  status: 200
}

export type getCustomerResponseSuccess = (getCustomerResponse200) & {
  headers: Headers;
};
;

export type getCustomerResponse = (getCustomerResponseSuccess)

export const getGetCustomerUrl = (id: number,) => {




  return `/customers/${id}`
}

export const getCustomer = async (id: number, options?: RequestInit): Promise<getCustomerResponse> => {

  return customInstance<getCustomerResponse>(getGetCustomerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerQueryKey = (id: number,) => {
    return [
    `/customers/${id}`
    ] as const;
    }


export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = unknown


export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گرفتن اطلاعات مشتری
 */

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary به‌روزرسانی مشتری
 */
export type updateCustomerResponse200 = {
  data: ResponseCustomerDto
  status: 200
}

export type updateCustomerResponseSuccess = (updateCustomerResponse200) & {
  headers: Headers;
};
;

export type updateCustomerResponse = (updateCustomerResponseSuccess)

export const getUpdateCustomerUrl = (id: number,) => {




  return `/customers/${id}`
}

export const updateCustomer = async (id: number,
    updateCustomerDto: UpdateCustomerDto, options?: RequestInit): Promise<updateCustomerResponse> => {

  return customInstance<updateCustomerResponse>(getUpdateCustomerUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCustomerDto,)
  }
);}




export const getUpdateCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: UpdateCustomerDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: UpdateCustomerDto}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {id: number;data: UpdateCustomerDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = UpdateCustomerDto
    export type UpdateCustomerMutationError = unknown

    /**
 * @summary به‌روزرسانی مشتری
 */
export const useUpdateCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: UpdateCustomerDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {id: number;data: UpdateCustomerDto},
        TContext
      > => {
      return useMutation(getUpdateCustomerMutationOptions(options), queryClient);
    }

/**
 * @summary حذف مشتری
 */
export type deleteCustomerResponse200 = {
  data: ResponseCustomerDto
  status: 200
}

export type deleteCustomerResponseSuccess = (deleteCustomerResponse200) & {
  headers: Headers;
};
;

export type deleteCustomerResponse = (deleteCustomerResponseSuccess)

export const getDeleteCustomerUrl = (id: number,) => {




  return `/customers/${id}`
}

export const deleteCustomer = async (id: number, options?: RequestInit): Promise<deleteCustomerResponse> => {

  return customInstance<deleteCustomerResponse>(getDeleteCustomerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomer>>>

    export type DeleteCustomerMutationError = unknown

    /**
 * @summary حذف مشتری
 */
export const useDeleteCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomer>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCustomerMutationOptions(options), queryClient);
    }

/**
 * @summary ثبت سفارش جدید
 */
export type createOrderResponse201 = {
  data: ResponseOrderDto
  status: 201
}

export type createOrderResponseSuccess = (createOrderResponse201) & {
  headers: Headers;
};
;

export type createOrderResponse = (createOrderResponseSuccess)

export const getCreateOrderUrl = () => {




  return `/orders`
}

export const createOrder = async (createOrderDto: CreateOrderDto, options?: RequestInit): Promise<createOrderResponse> => {

  return customInstance<createOrderResponse>(getCreateOrderUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createOrderDto,)
  }
);}




export const getCreateOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: CreateOrderDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: CreateOrderDto}, TContext> => {

const mutationKey = ['createOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOrder>>, {data: CreateOrderDto}> = (props) => {
          const {data} = props ?? {};

          return  createOrder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createOrder>>>
    export type CreateOrderMutationBody = CreateOrderDto
    export type CreateOrderMutationError = unknown

    /**
 * @summary ثبت سفارش جدید
 */
export const useCreateOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOrder>>, TError,{data: CreateOrderDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOrder>>,
        TError,
        {data: CreateOrderDto},
        TContext
      > => {
      return useMutation(getCreateOrderMutationOptions(options), queryClient);
    }

/**
 * @summary لیست سفارش‌ها
 */
export type getOrdersResponse200 = {
  data: ResponseOrderArrayDto
  status: 200
}

export type getOrdersResponseSuccess = (getOrdersResponse200) & {
  headers: Headers;
};
;

export type getOrdersResponse = (getOrdersResponseSuccess)

export const getGetOrdersUrl = (params?: GetOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orders?${stringifiedParams}` : `/orders`
}

export const getOrders = async (params?: GetOrdersParams, options?: RequestInit): Promise<getOrdersResponse> => {

  return customInstance<getOrdersResponse>(getGetOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrdersQueryKey = (params?: GetOrdersParams,) => {
    return [
    `/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(params?: GetOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrders>>> = ({ signal }) => getOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrders>>>
export type GetOrdersQueryError = unknown


export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
 params: undefined |  GetOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrders>>,
          TError,
          Awaited<ReturnType<typeof getOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
 params?: GetOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrders>>,
          TError,
          Awaited<ReturnType<typeof getOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
 params?: GetOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست سفارش‌ها
 */

export function useGetOrders<TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
 params?: GetOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary آمار سفارش‌ها
 */
export type getOrderStatsResponse200 = {
  data: ResponseOrderStatsDto
  status: 200
}

export type getOrderStatsResponseSuccess = (getOrderStatsResponse200) & {
  headers: Headers;
};
;

export type getOrderStatsResponse = (getOrderStatsResponseSuccess)

export const getGetOrderStatsUrl = (params?: GetOrderStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/orders/stats?${stringifiedParams}` : `/orders/stats`
}

export const getOrderStats = async (params?: GetOrderStatsParams, options?: RequestInit): Promise<getOrderStatsResponse> => {

  return customInstance<getOrderStatsResponse>(getGetOrderStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderStatsQueryKey = (params?: GetOrderStatsParams,) => {
    return [
    `/orders/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetOrderStatsQueryOptions = <TData = Awaited<ReturnType<typeof getOrderStats>>, TError = unknown>(params?: GetOrderStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderStats>>> = ({ signal }) => getOrderStats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderStats>>>
export type GetOrderStatsQueryError = unknown


export function useGetOrderStats<TData = Awaited<ReturnType<typeof getOrderStats>>, TError = unknown>(
 params: undefined |  GetOrderStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderStats>>,
          TError,
          Awaited<ReturnType<typeof getOrderStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderStats<TData = Awaited<ReturnType<typeof getOrderStats>>, TError = unknown>(
 params?: GetOrderStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderStats>>,
          TError,
          Awaited<ReturnType<typeof getOrderStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderStats<TData = Awaited<ReturnType<typeof getOrderStats>>, TError = unknown>(
 params?: GetOrderStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary آمار سفارش‌ها
 */

export function useGetOrderStats<TData = Awaited<ReturnType<typeof getOrderStats>>, TError = unknown>(
 params?: GetOrderStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary دریافت لینک پرداخت سفارش
 */
export type getOrderPaymentLinkResponse200 = {
  data: ResponsePaymentLinkDto
  status: 200
}

export type getOrderPaymentLinkResponseSuccess = (getOrderPaymentLinkResponse200) & {
  headers: Headers;
};
;

export type getOrderPaymentLinkResponse = (getOrderPaymentLinkResponseSuccess)

export const getGetOrderPaymentLinkUrl = (id: number,) => {




  return `/orders/${id}/payment-link`
}

export const getOrderPaymentLink = async (id: number, options?: RequestInit): Promise<getOrderPaymentLinkResponse> => {

  return customInstance<getOrderPaymentLinkResponse>(getGetOrderPaymentLinkUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderPaymentLinkQueryKey = (id: number,) => {
    return [
    `/orders/${id}/payment-link`
    ] as const;
    }


export const getGetOrderPaymentLinkQueryOptions = <TData = Awaited<ReturnType<typeof getOrderPaymentLink>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderPaymentLinkQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderPaymentLink>>> = ({ signal }) => getOrderPaymentLink(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderPaymentLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderPaymentLink>>>
export type GetOrderPaymentLinkQueryError = unknown


export function useGetOrderPaymentLink<TData = Awaited<ReturnType<typeof getOrderPaymentLink>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderPaymentLink>>,
          TError,
          Awaited<ReturnType<typeof getOrderPaymentLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderPaymentLink<TData = Awaited<ReturnType<typeof getOrderPaymentLink>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderPaymentLink>>,
          TError,
          Awaited<ReturnType<typeof getOrderPaymentLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrderPaymentLink<TData = Awaited<ReturnType<typeof getOrderPaymentLink>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دریافت لینک پرداخت سفارش
 */

export function useGetOrderPaymentLink<TData = Awaited<ReturnType<typeof getOrderPaymentLink>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrderPaymentLink>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderPaymentLinkQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary بازتولید لینک پرداخت سفارش
 */
export type regenerateOrderPaymentLinkResponse200 = {
  data: ResponsePaymentLinkDto
  status: 200
}

export type regenerateOrderPaymentLinkResponseSuccess = (regenerateOrderPaymentLinkResponse200) & {
  headers: Headers;
};
;

export type regenerateOrderPaymentLinkResponse = (regenerateOrderPaymentLinkResponseSuccess)

export const getRegenerateOrderPaymentLinkUrl = (id: number,) => {




  return `/orders/${id}/payment-link/regenerate`
}

export const regenerateOrderPaymentLink = async (id: number, options?: RequestInit): Promise<regenerateOrderPaymentLinkResponse> => {

  return customInstance<regenerateOrderPaymentLinkResponse>(getRegenerateOrderPaymentLinkUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRegenerateOrderPaymentLinkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateOrderPaymentLink>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateOrderPaymentLink>>, TError,{id: number}, TContext> => {

const mutationKey = ['regenerateOrderPaymentLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateOrderPaymentLink>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  regenerateOrderPaymentLink(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateOrderPaymentLinkMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateOrderPaymentLink>>>

    export type RegenerateOrderPaymentLinkMutationError = unknown

    /**
 * @summary بازتولید لینک پرداخت سفارش
 */
export const useRegenerateOrderPaymentLink = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateOrderPaymentLink>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateOrderPaymentLink>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getRegenerateOrderPaymentLinkMutationOptions(options), queryClient);
    }

/**
 * @summary گرفتن اطلاعات سفارش
 */
export type getOrderResponse200 = {
  data: ResponseOrderDto
  status: 200
}

export type getOrderResponseSuccess = (getOrderResponse200) & {
  headers: Headers;
};
;

export type getOrderResponse = (getOrderResponseSuccess)

export const getGetOrderUrl = (id: number,) => {




  return `/orders/${id}`
}

export const getOrder = async (id: number, options?: RequestInit): Promise<getOrderResponse> => {

  return customInstance<getOrderResponse>(getGetOrderUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOrderQueryKey = (id: number,) => {
    return [
    `/orders/${id}`
    ] as const;
    }


export const getGetOrderQueryOptions = <TData = Awaited<ReturnType<typeof getOrder>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({ signal }) => getOrder(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getOrder>>>
export type GetOrderQueryError = unknown


export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrder>>,
          TError,
          Awaited<ReturnType<typeof getOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گرفتن اطلاعات سفارش
 */

export function useGetOrder<TData = Awaited<ReturnType<typeof getOrder>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrderQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ویرایش سفارش
 */
export type updateOrderResponse200 = {
  data: ResponseOrderDto
  status: 200
}

export type updateOrderResponseSuccess = (updateOrderResponse200) & {
  headers: Headers;
};
;

export type updateOrderResponse = (updateOrderResponseSuccess)

export const getUpdateOrderUrl = (id: number,) => {




  return `/orders/${id}`
}

export const updateOrder = async (id: number,
    updateOrderDto: UpdateOrderDto, options?: RequestInit): Promise<updateOrderResponse> => {

  return customInstance<updateOrderResponse>(getUpdateOrderUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrderDto,)
  }
);}




export const getUpdateOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: UpdateOrderDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: UpdateOrderDto}, TContext> => {

const mutationKey = ['updateOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrder>>, {id: number;data: UpdateOrderDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrder(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrder>>>
    export type UpdateOrderMutationBody = UpdateOrderDto
    export type UpdateOrderMutationError = unknown

    /**
 * @summary ویرایش سفارش
 */
export const useUpdateOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrder>>, TError,{id: number;data: UpdateOrderDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrder>>,
        TError,
        {id: number;data: UpdateOrderDto},
        TContext
      > => {
      return useMutation(getUpdateOrderMutationOptions(options), queryClient);
    }

/**
 * @summary حذف سفارش
 */
export type deleteOrderResponse200 = {
  data: ResponseOrderDto
  status: 200
}

export type deleteOrderResponseSuccess = (deleteOrderResponse200) & {
  headers: Headers;
};
;

export type deleteOrderResponse = (deleteOrderResponseSuccess)

export const getDeleteOrderUrl = (id: number,) => {




  return `/orders/${id}`
}

export const deleteOrder = async (id: number, options?: RequestInit): Promise<deleteOrderResponse> => {

  return customInstance<deleteOrderResponse>(getDeleteOrderUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrder>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrder>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteOrder(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrder>>>

    export type DeleteOrderMutationError = unknown

    /**
 * @summary حذف سفارش
 */
export const useDeleteOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrder>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrder>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteOrderMutationOptions(options), queryClient);
    }

/**
 * @summary به‌روزرسانی وضعیت سفارش
 */
export type updateOrderStatusResponse200 = {
  data: ResponseOrderDto
  status: 200
}

export type updateOrderStatusResponseSuccess = (updateOrderStatusResponse200) & {
  headers: Headers;
};
;

export type updateOrderStatusResponse = (updateOrderStatusResponseSuccess)

export const getUpdateOrderStatusUrl = (id: number,) => {




  return `/orders/${id}/status`
}

export const updateOrderStatus = async (id: number,
    updateOrderStatusDto: UpdateOrderStatusDto, options?: RequestInit): Promise<updateOrderStatusResponse> => {

  return customInstance<updateOrderStatusResponse>(getUpdateOrderStatusUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateOrderStatusDto,)
  }
);}




export const getUpdateOrderStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStatus>>, TError,{id: number;data: UpdateOrderStatusDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOrderStatus>>, TError,{id: number;data: UpdateOrderStatusDto}, TContext> => {

const mutationKey = ['updateOrderStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOrderStatus>>, {id: number;data: UpdateOrderStatusDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrderStatus(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrderStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateOrderStatus>>>
    export type UpdateOrderStatusMutationBody = UpdateOrderStatusDto
    export type UpdateOrderStatusMutationError = unknown

    /**
 * @summary به‌روزرسانی وضعیت سفارش
 */
export const useUpdateOrderStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOrderStatus>>, TError,{id: number;data: UpdateOrderStatusDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOrderStatus>>,
        TError,
        {id: number;data: UpdateOrderStatusDto},
        TContext
      > => {
      return useMutation(getUpdateOrderStatusMutationOptions(options), queryClient);
    }

/**
 * @summary ساخت محصول جدید
 */
export type createProductResponse201 = {
  data: ResponseProductDto
  status: 201
}

export type createProductResponseSuccess = (createProductResponse201) & {
  headers: Headers;
};
;

export type createProductResponse = (createProductResponseSuccess)

export const getCreateProductUrl = () => {




  return `/products`
}

export const createProduct = async (createProductDto: CreateProductDto, options?: RequestInit): Promise<createProductResponse> => {

  return customInstance<createProductResponse>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProductDto,)
  }
);}




export const getCreateProductMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: CreateProductDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: CreateProductDto}, TContext> => {

const mutationKey = ['createProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, {data: CreateProductDto}> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = CreateProductDto
    export type CreateProductMutationError = unknown

    /**
 * @summary ساخت محصول جدید
 */
export const useCreateProduct = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: CreateProductDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        {data: CreateProductDto},
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options), queryClient);
    }

/**
 * @summary لیست محصولات
 */
export type getProductsResponse200 = {
  data: ResponseProductArrayDto
  status: 200
}

export type getProductsResponseSuccess = (getProductsResponse200) & {
  headers: Headers;
};
;

export type getProductsResponse = (getProductsResponseSuccess)

export const getGetProductsUrl = (params?: GetProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/products?${stringifiedParams}` : `/products`
}

export const getProducts = async (params?: GetProductsParams, options?: RequestInit): Promise<getProductsResponse> => {

  return customInstance<getProductsResponse>(getGetProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductsQueryKey = (params?: GetProductsParams,) => {
    return [
    `/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductsQueryOptions = <TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsQueryError = unknown


export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 params: undefined |  GetProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست محصولات
 */

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 params?: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary آمار محصولات
 */
export type getProductStatsResponse200 = {
  data: ResponseProductStatsDto
  status: 200
}

export type getProductStatsResponseSuccess = (getProductStatsResponse200) & {
  headers: Headers;
};
;

export type getProductStatsResponse = (getProductStatsResponseSuccess)

export const getGetProductStatsUrl = (params?: GetProductStatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/products/stats?${stringifiedParams}` : `/products/stats`
}

export const getProductStats = async (params?: GetProductStatsParams, options?: RequestInit): Promise<getProductStatsResponse> => {

  return customInstance<getProductStatsResponse>(getGetProductStatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductStatsQueryKey = (params?: GetProductStatsParams,) => {
    return [
    `/products/stats`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductStatsQueryOptions = <TData = Awaited<ReturnType<typeof getProductStats>>, TError = unknown>(params?: GetProductStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductStats>>> = ({ signal }) => getProductStats(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductStats>>>
export type GetProductStatsQueryError = unknown


export function useGetProductStats<TData = Awaited<ReturnType<typeof getProductStats>>, TError = unknown>(
 params: undefined |  GetProductStatsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductStats>>,
          TError,
          Awaited<ReturnType<typeof getProductStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductStats<TData = Awaited<ReturnType<typeof getProductStats>>, TError = unknown>(
 params?: GetProductStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductStats>>,
          TError,
          Awaited<ReturnType<typeof getProductStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductStats<TData = Awaited<ReturnType<typeof getProductStats>>, TError = unknown>(
 params?: GetProductStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary آمار محصولات
 */

export function useGetProductStats<TData = Awaited<ReturnType<typeof getProductStats>>, TError = unknown>(
 params?: GetProductStatsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductStats>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary گرفتن اطلاعات محصول
 */
export type getProductResponse200 = {
  data: ResponseProductDto
  status: 200
}

export type getProductResponseSuccess = (getProductResponse200) & {
  headers: Headers;
};
;

export type getProductResponse = (getProductResponseSuccess)

export const getGetProductUrl = (id: number,) => {




  return `/products/${id}`
}

export const getProduct = async (id: number, options?: RequestInit): Promise<getProductResponse> => {

  return customInstance<getProductResponse>(getGetProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (id: number,) => {
    return [
    `/products/${id}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = unknown


export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary گرفتن اطلاعات محصول
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary به‌روزرسانی محصول
 */
export type updateProductResponse200 = {
  data: ResponseProductDto
  status: 200
}

export type updateProductResponseSuccess = (updateProductResponse200) & {
  headers: Headers;
};
;

export type updateProductResponse = (updateProductResponseSuccess)

export const getUpdateProductUrl = (id: number,) => {




  return `/products/${id}`
}

export const updateProduct = async (id: number,
    updateProductDto: UpdateProductDto, options?: RequestInit): Promise<updateProductResponse> => {

  return customInstance<updateProductResponse>(getUpdateProductUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProductDto,)
  }
);}




export const getUpdateProductMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: UpdateProductDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: UpdateProductDto}, TContext> => {

const mutationKey = ['updateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, {id: number;data: UpdateProductDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = UpdateProductDto
    export type UpdateProductMutationError = unknown

    /**
 * @summary به‌روزرسانی محصول
 */
export const useUpdateProduct = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: UpdateProductDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        {id: number;data: UpdateProductDto},
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options), queryClient);
    }

/**
 * @summary حذف محصول
 */
export type deleteProductResponse200 = {
  data: ResponseProductDto
  status: 200
}

export type deleteProductResponseSuccess = (deleteProductResponse200) & {
  headers: Headers;
};
;

export type deleteProductResponse = (deleteProductResponseSuccess)

export const getDeleteProductUrl = (id: number,) => {




  return `/products/${id}`
}

export const deleteProduct = async (id: number, options?: RequestInit): Promise<deleteProductResponse> => {

  return customInstance<deleteProductResponse>(getDeleteProductUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProduct(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>

    export type DeleteProductMutationError = unknown

    /**
 * @summary حذف محصول
 */
export const useDeleteProduct = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProductMutationOptions(options), queryClient);
    }

/**
 * @summary ایجاد دسته‌بندی محصول
 */
export type createProductCategoryResponse201 = {
  data: ResponseProductCategoryDto
  status: 201
}

export type createProductCategoryResponseSuccess = (createProductCategoryResponse201) & {
  headers: Headers;
};
;

export type createProductCategoryResponse = (createProductCategoryResponseSuccess)

export const getCreateProductCategoryUrl = () => {




  return `/product-categories`
}

export const createProductCategory = async (createProductCategoryDto: CreateProductCategoryDto, options?: RequestInit): Promise<createProductCategoryResponse> => {

  return customInstance<createProductCategoryResponse>(getCreateProductCategoryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProductCategoryDto,)
  }
);}




export const getCreateProductCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductCategory>>, TError,{data: CreateProductCategoryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductCategory>>, TError,{data: CreateProductCategoryDto}, TContext> => {

const mutationKey = ['createProductCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductCategory>>, {data: CreateProductCategoryDto}> = (props) => {
          const {data} = props ?? {};

          return  createProductCategory(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof createProductCategory>>>
    export type CreateProductCategoryMutationBody = CreateProductCategoryDto
    export type CreateProductCategoryMutationError = unknown

    /**
 * @summary ایجاد دسته‌بندی محصول
 */
export const useCreateProductCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductCategory>>, TError,{data: CreateProductCategoryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProductCategory>>,
        TError,
        {data: CreateProductCategoryDto},
        TContext
      > => {
      return useMutation(getCreateProductCategoryMutationOptions(options), queryClient);
    }

/**
 * @summary لیست دسته‌بندی‌های محصول
 */
export type getProductCategoriesResponse200 = {
  data: ResponseProductCategoryArrayDto
  status: 200
}

export type getProductCategoriesResponseSuccess = (getProductCategoriesResponse200) & {
  headers: Headers;
};
;

export type getProductCategoriesResponse = (getProductCategoriesResponseSuccess)

export const getGetProductCategoriesUrl = (params?: GetProductCategoriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/product-categories?${stringifiedParams}` : `/product-categories`
}

export const getProductCategories = async (params?: GetProductCategoriesParams, options?: RequestInit): Promise<getProductCategoriesResponse> => {

  return customInstance<getProductCategoriesResponse>(getGetProductCategoriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductCategoriesQueryKey = (params?: GetProductCategoriesParams,) => {
    return [
    `/product-categories`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getProductCategories>>, TError = unknown>(params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductCategoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCategories>>> = ({ signal }) => getProductCategories(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductCategories>>>
export type GetProductCategoriesQueryError = unknown


export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = unknown>(
 params: undefined |  GetProductCategoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategories>>,
          TError,
          Awaited<ReturnType<typeof getProductCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = unknown>(
 params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategories>>,
          TError,
          Awaited<ReturnType<typeof getProductCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = unknown>(
 params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست دسته‌بندی‌های محصول
 */

export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = unknown>(
 params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary جزئیات دسته‌بندی
 */
export type getProductCategoryResponse200 = {
  data: ResponseProductCategoryDto
  status: 200
}

export type getProductCategoryResponseSuccess = (getProductCategoryResponse200) & {
  headers: Headers;
};
;

export type getProductCategoryResponse = (getProductCategoryResponseSuccess)

export const getGetProductCategoryUrl = (id: number,) => {




  return `/product-categories/${id}`
}

export const getProductCategory = async (id: number, options?: RequestInit): Promise<getProductCategoryResponse> => {

  return customInstance<getProductCategoryResponse>(getGetProductCategoryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductCategoryQueryKey = (id: number,) => {
    return [
    `/product-categories/${id}`
    ] as const;
    }


export const getGetProductCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getProductCategory>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductCategoryQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCategory>>> = ({ signal }) => getProductCategory(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getProductCategory>>>
export type GetProductCategoryQueryError = unknown


export function useGetProductCategory<TData = Awaited<ReturnType<typeof getProductCategory>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategory>>,
          TError,
          Awaited<ReturnType<typeof getProductCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategory<TData = Awaited<ReturnType<typeof getProductCategory>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategory>>,
          TError,
          Awaited<ReturnType<typeof getProductCategory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategory<TData = Awaited<ReturnType<typeof getProductCategory>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary جزئیات دسته‌بندی
 */

export function useGetProductCategory<TData = Awaited<ReturnType<typeof getProductCategory>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductCategoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ویرایش دسته‌بندی
 */
export type updateProductCategoryResponse200 = {
  data: ResponseProductCategoryDto
  status: 200
}

export type updateProductCategoryResponseSuccess = (updateProductCategoryResponse200) & {
  headers: Headers;
};
;

export type updateProductCategoryResponse = (updateProductCategoryResponseSuccess)

export const getUpdateProductCategoryUrl = (id: number,) => {




  return `/product-categories/${id}`
}

export const updateProductCategory = async (id: number,
    updateProductCategoryDto: UpdateProductCategoryDto, options?: RequestInit): Promise<updateProductCategoryResponse> => {

  return customInstance<updateProductCategoryResponse>(getUpdateProductCategoryUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProductCategoryDto,)
  }
);}




export const getUpdateProductCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductCategory>>, TError,{id: number;data: UpdateProductCategoryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductCategory>>, TError,{id: number;data: UpdateProductCategoryDto}, TContext> => {

const mutationKey = ['updateProductCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductCategory>>, {id: number;data: UpdateProductCategoryDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProductCategory(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductCategory>>>
    export type UpdateProductCategoryMutationBody = UpdateProductCategoryDto
    export type UpdateProductCategoryMutationError = unknown

    /**
 * @summary ویرایش دسته‌بندی
 */
export const useUpdateProductCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductCategory>>, TError,{id: number;data: UpdateProductCategoryDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductCategory>>,
        TError,
        {id: number;data: UpdateProductCategoryDto},
        TContext
      > => {
      return useMutation(getUpdateProductCategoryMutationOptions(options), queryClient);
    }

/**
 * @summary حذف دسته‌بندی
 */
export type deleteProductCategoryResponse200 = {
  data: ResponseProductCategoryDto
  status: 200
}

export type deleteProductCategoryResponseSuccess = (deleteProductCategoryResponse200) & {
  headers: Headers;
};
;

export type deleteProductCategoryResponse = (deleteProductCategoryResponseSuccess)

export const getDeleteProductCategoryUrl = (id: number,) => {




  return `/product-categories/${id}`
}

export const deleteProductCategory = async (id: number, options?: RequestInit): Promise<deleteProductCategoryResponse> => {

  return customInstance<deleteProductCategoryResponse>(getDeleteProductCategoryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategory>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProductCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductCategory>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductCategory(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductCategory>>>

    export type DeleteProductCategoryMutationError = unknown

    /**
 * @summary حذف دسته‌بندی
 */
export const useDeleteProductCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategory>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductCategory>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProductCategoryMutationOptions(options), queryClient);
    }

/**
 * @summary ایجاد پرداخت جدید
 */
export type createPaymentResponse201 = {
  data: ResponsePaymentDto
  status: 201
}

export type createPaymentResponseSuccess = (createPaymentResponse201) & {
  headers: Headers;
};
;

export type createPaymentResponse = (createPaymentResponseSuccess)

export const getCreatePaymentUrl = () => {




  return `/payments`
}

export const createPayment = async (createPaymentDto: CreatePaymentDto, options?: RequestInit): Promise<createPaymentResponse> => {

  return customInstance<createPaymentResponse>(getCreatePaymentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPaymentDto,)
  }
);}




export const getCreatePaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayment>>, TError,{data: CreatePaymentDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPayment>>, TError,{data: CreatePaymentDto}, TContext> => {

const mutationKey = ['createPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPayment>>, {data: CreatePaymentDto}> = (props) => {
          const {data} = props ?? {};

          return  createPayment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof createPayment>>>
    export type CreatePaymentMutationBody = CreatePaymentDto
    export type CreatePaymentMutationError = unknown

    /**
 * @summary ایجاد پرداخت جدید
 */
export const useCreatePayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPayment>>, TError,{data: CreatePaymentDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPayment>>,
        TError,
        {data: CreatePaymentDto},
        TContext
      > => {
      return useMutation(getCreatePaymentMutationOptions(options), queryClient);
    }

/**
 * @summary لیست پرداخت‌ها
 */
export type getPaymentsResponse200 = {
  data: ResponsePaymentArrayDto
  status: 200
}

export type getPaymentsResponseSuccess = (getPaymentsResponse200) & {
  headers: Headers;
};
;

export type getPaymentsResponse = (getPaymentsResponseSuccess)

export const getGetPaymentsUrl = () => {




  return `/payments`
}

export const getPayments = async ( options?: RequestInit): Promise<getPaymentsResponse> => {

  return customInstance<getPaymentsResponse>(getGetPaymentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaymentsQueryKey = () => {
    return [
    `/payments`
    ] as const;
    }


export const getGetPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayments>>> = ({ signal }) => getPayments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayments>>>
export type GetPaymentsQueryError = unknown


export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayments>>,
          TError,
          Awaited<ReturnType<typeof getPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayments>>,
          TError,
          Awaited<ReturnType<typeof getPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لیست پرداخت‌ها
 */

export function useGetPayments<TData = Awaited<ReturnType<typeof getPayments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary دریافت اطلاعات پرداخت
 */
export type getPaymentResponse200 = {
  data: ResponsePaymentDto
  status: 200
}

export type getPaymentResponseSuccess = (getPaymentResponse200) & {
  headers: Headers;
};
;

export type getPaymentResponse = (getPaymentResponseSuccess)

export const getGetPaymentUrl = (id: number,) => {




  return `/payments/${id}`
}

export const getPayment = async (id: number, options?: RequestInit): Promise<getPaymentResponse> => {

  return customInstance<getPaymentResponse>(getGetPaymentUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPaymentQueryKey = (id: number,) => {
    return [
    `/payments/${id}`
    ] as const;
    }


export const getGetPaymentQueryOptions = <TData = Awaited<ReturnType<typeof getPayment>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayment>>> = ({ signal }) => getPayment(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getPayment>>>
export type GetPaymentQueryError = unknown


export function useGetPayment<TData = Awaited<ReturnType<typeof getPayment>>, TError = unknown>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayment>>,
          TError,
          Awaited<ReturnType<typeof getPayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayment<TData = Awaited<ReturnType<typeof getPayment>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayment>>,
          TError,
          Awaited<ReturnType<typeof getPayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayment<TData = Awaited<ReturnType<typeof getPayment>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دریافت اطلاعات پرداخت
 */

export function useGetPayment<TData = Awaited<ReturnType<typeof getPayment>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary حذف پرداخت
 */
export type deletePaymentResponse200 = {
  data: ResponsePaymentDto
  status: 200
}

export type deletePaymentResponseSuccess = (deletePaymentResponse200) & {
  headers: Headers;
};
;

export type deletePaymentResponse = (deletePaymentResponseSuccess)

export const getDeletePaymentUrl = (id: number,) => {




  return `/payments/${id}`
}

export const deletePayment = async (id: number, options?: RequestInit): Promise<deletePaymentResponse> => {

  return customInstance<deletePaymentResponse>(getDeletePaymentUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayment>>, TError,{id: number}, TContext> => {

const mutationKey = ['deletePayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayment>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deletePayment(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayment>>>

    export type DeletePaymentMutationError = unknown

    /**
 * @summary حذف پرداخت
 */
export const useDeletePayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayment>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayment>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeletePaymentMutationOptions(options), queryClient);
    }

/**
 * @summary تأیید پرداخت
 */
export type verifyPaymentResponse200 = {
  data: ResponsePaymentDto
  status: 200
}

export type verifyPaymentResponseSuccess = (verifyPaymentResponse200) & {
  headers: Headers;
};
;

export type verifyPaymentResponse = (verifyPaymentResponseSuccess)

export const getVerifyPaymentUrl = (id: number,) => {




  return `/payments/${id}/verify`
}

export const verifyPayment = async (id: number,
    verifyPaymentDto: VerifyPaymentDto, options?: RequestInit): Promise<verifyPaymentResponse> => {

  return customInstance<verifyPaymentResponse>(getVerifyPaymentUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verifyPaymentDto,)
  }
);}




export const getVerifyPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPayment>>, TError,{id: number;data: VerifyPaymentDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyPayment>>, TError,{id: number;data: VerifyPaymentDto}, TContext> => {

const mutationKey = ['verifyPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyPayment>>, {id: number;data: VerifyPaymentDto}> = (props) => {
          const {id,data} = props ?? {};

          return  verifyPayment(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof verifyPayment>>>
    export type VerifyPaymentMutationBody = VerifyPaymentDto
    export type VerifyPaymentMutationError = unknown

    /**
 * @summary تأیید پرداخت
 */
export const useVerifyPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPayment>>, TError,{id: number;data: VerifyPaymentDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyPayment>>,
        TError,
        {id: number;data: VerifyPaymentDto},
        TContext
      > => {
      return useMutation(getVerifyPaymentMutationOptions(options), queryClient);
    }

/**
 * @summary مشاهده سبد خرید با توکن
 */
export type getPublicCheckoutResponse200 = {
  data: ResponsePublicCheckoutDto
  status: 200
}

export type getPublicCheckoutResponseSuccess = (getPublicCheckoutResponse200) & {
  headers: Headers;
};
;

export type getPublicCheckoutResponse = (getPublicCheckoutResponseSuccess)

export const getGetPublicCheckoutUrl = (token: string,) => {




  return `/public/checkout/${token}`
}

export const getPublicCheckout = async (token: string, options?: RequestInit): Promise<getPublicCheckoutResponse> => {

  return customInstance<getPublicCheckoutResponse>(getGetPublicCheckoutUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicCheckoutQueryKey = (token: string,) => {
    return [
    `/public/checkout/${token}`
    ] as const;
    }


export const getGetPublicCheckoutQueryOptions = <TData = Awaited<ReturnType<typeof getPublicCheckout>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckout>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicCheckoutQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicCheckout>>> = ({ signal }) => getPublicCheckout(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicCheckoutQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicCheckout>>>
export type GetPublicCheckoutQueryError = unknown


export function useGetPublicCheckout<TData = Awaited<ReturnType<typeof getPublicCheckout>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCheckout>>,
          TError,
          Awaited<ReturnType<typeof getPublicCheckout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCheckout<TData = Awaited<ReturnType<typeof getPublicCheckout>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCheckout>>,
          TError,
          Awaited<ReturnType<typeof getPublicCheckout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCheckout<TData = Awaited<ReturnType<typeof getPublicCheckout>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckout>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary مشاهده سبد خرید با توکن
 */

export function useGetPublicCheckout<TData = Awaited<ReturnType<typeof getPublicCheckout>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckout>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicCheckoutQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ارسال کد تأیید به موبایل مشتری
 */
export type requestPublicCheckoutOtpResponse200 = {
  data: ResponsePublicOtpDto
  status: 200
}

export type requestPublicCheckoutOtpResponseSuccess = (requestPublicCheckoutOtpResponse200) & {
  headers: Headers;
};
;

export type requestPublicCheckoutOtpResponse = (requestPublicCheckoutOtpResponseSuccess)

export const getRequestPublicCheckoutOtpUrl = (token: string,) => {




  return `/public/checkout/${token}/otp`
}

export const requestPublicCheckoutOtp = async (token: string,
    requestCheckoutOtpDto: RequestCheckoutOtpDto, options?: RequestInit): Promise<requestPublicCheckoutOtpResponse> => {

  return customInstance<requestPublicCheckoutOtpResponse>(getRequestPublicCheckoutOtpUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      requestCheckoutOtpDto,)
  }
);}




export const getRequestPublicCheckoutOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPublicCheckoutOtp>>, TError,{token: string;data: RequestCheckoutOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPublicCheckoutOtp>>, TError,{token: string;data: RequestCheckoutOtpDto}, TContext> => {

const mutationKey = ['requestPublicCheckoutOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPublicCheckoutOtp>>, {token: string;data: RequestCheckoutOtpDto}> = (props) => {
          const {token,data} = props ?? {};

          return  requestPublicCheckoutOtp(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPublicCheckoutOtpMutationResult = NonNullable<Awaited<ReturnType<typeof requestPublicCheckoutOtp>>>
    export type RequestPublicCheckoutOtpMutationBody = RequestCheckoutOtpDto
    export type RequestPublicCheckoutOtpMutationError = unknown

    /**
 * @summary ارسال کد تأیید به موبایل مشتری
 */
export const useRequestPublicCheckoutOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPublicCheckoutOtp>>, TError,{token: string;data: RequestCheckoutOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestPublicCheckoutOtp>>,
        TError,
        {token: string;data: RequestCheckoutOtpDto},
        TContext
      > => {
      return useMutation(getRequestPublicCheckoutOtpMutationOptions(options), queryClient);
    }

/**
 * @summary تأیید موبایل مشتری با کد یک‌بارمصرف
 */
export type verifyPublicCheckoutOtpResponse200 = {
  data: ResponsePublicCheckoutDto
  status: 200
}

export type verifyPublicCheckoutOtpResponseSuccess = (verifyPublicCheckoutOtpResponse200) & {
  headers: Headers;
};
;

export type verifyPublicCheckoutOtpResponse = (verifyPublicCheckoutOtpResponseSuccess)

export const getVerifyPublicCheckoutOtpUrl = (token: string,) => {




  return `/public/checkout/${token}/otp/verify`
}

export const verifyPublicCheckoutOtp = async (token: string,
    verifyCheckoutOtpDto: VerifyCheckoutOtpDto, options?: RequestInit): Promise<verifyPublicCheckoutOtpResponse> => {

  return customInstance<verifyPublicCheckoutOtpResponse>(getVerifyPublicCheckoutOtpUrl(token),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verifyCheckoutOtpDto,)
  }
);}




export const getVerifyPublicCheckoutOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPublicCheckoutOtp>>, TError,{token: string;data: VerifyCheckoutOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyPublicCheckoutOtp>>, TError,{token: string;data: VerifyCheckoutOtpDto}, TContext> => {

const mutationKey = ['verifyPublicCheckoutOtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyPublicCheckoutOtp>>, {token: string;data: VerifyCheckoutOtpDto}> = (props) => {
          const {token,data} = props ?? {};

          return  verifyPublicCheckoutOtp(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyPublicCheckoutOtpMutationResult = NonNullable<Awaited<ReturnType<typeof verifyPublicCheckoutOtp>>>
    export type VerifyPublicCheckoutOtpMutationBody = VerifyCheckoutOtpDto
    export type VerifyPublicCheckoutOtpMutationError = unknown

    /**
 * @summary تأیید موبایل مشتری با کد یک‌بارمصرف
 */
export const useVerifyPublicCheckoutOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyPublicCheckoutOtp>>, TError,{token: string;data: VerifyCheckoutOtpDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyPublicCheckoutOtp>>,
        TError,
        {token: string;data: VerifyCheckoutOtpDto},
        TContext
      > => {
      return useMutation(getVerifyPublicCheckoutOtpMutationOptions(options), queryClient);
    }

/**
 * @summary تبدیل موقعیت نقشه به آدرس
 */
export type reverseGeocodePublicCheckoutResponse200 = {
  data: ResponseReverseGeocodeDto
  status: 200
}

export type reverseGeocodePublicCheckoutResponseSuccess = (reverseGeocodePublicCheckoutResponse200) & {
  headers: Headers;
};
;

export type reverseGeocodePublicCheckoutResponse = (reverseGeocodePublicCheckoutResponseSuccess)

export const getReverseGeocodePublicCheckoutUrl = (token: string,
    params: ReverseGeocodePublicCheckoutParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/public/checkout/${token}/reverse-geocode?${stringifiedParams}` : `/public/checkout/${token}/reverse-geocode`
}

export const reverseGeocodePublicCheckout = async (token: string,
    params: ReverseGeocodePublicCheckoutParams, options?: RequestInit): Promise<reverseGeocodePublicCheckoutResponse> => {

  return customInstance<reverseGeocodePublicCheckoutResponse>(getReverseGeocodePublicCheckoutUrl(token,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReverseGeocodePublicCheckoutQueryKey = (token: string,
    params?: ReverseGeocodePublicCheckoutParams,) => {
    return [
    `/public/checkout/${token}/reverse-geocode`, ...(params ? [params] : [])
    ] as const;
    }


export const getReverseGeocodePublicCheckoutQueryOptions = <TData = Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError = unknown>(token: string,
    params: ReverseGeocodePublicCheckoutParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReverseGeocodePublicCheckoutQueryKey(token,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>> = ({ signal }) => reverseGeocodePublicCheckout(token,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ReverseGeocodePublicCheckoutQueryResult = NonNullable<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>>
export type ReverseGeocodePublicCheckoutQueryError = unknown


export function useReverseGeocodePublicCheckout<TData = Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError = unknown>(
 token: string,
    params: ReverseGeocodePublicCheckoutParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>,
          TError,
          Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReverseGeocodePublicCheckout<TData = Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError = unknown>(
 token: string,
    params: ReverseGeocodePublicCheckoutParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>,
          TError,
          Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useReverseGeocodePublicCheckout<TData = Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError = unknown>(
 token: string,
    params: ReverseGeocodePublicCheckoutParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary تبدیل موقعیت نقشه به آدرس
 */

export function useReverseGeocodePublicCheckout<TData = Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError = unknown>(
 token: string,
    params: ReverseGeocodePublicCheckoutParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof reverseGeocodePublicCheckout>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getReverseGeocodePublicCheckoutQueryOptions(token,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary ثبت/اصلاح اطلاعات مشتری
 */
export type submitPublicCustomerInfoResponse200 = {
  data: ResponsePublicCheckoutDto
  status: 200
}

export type submitPublicCustomerInfoResponseSuccess = (submitPublicCustomerInfoResponse200) & {
  headers: Headers;
};
;

export type submitPublicCustomerInfoResponse = (submitPublicCustomerInfoResponseSuccess)

export const getSubmitPublicCustomerInfoUrl = (token: string,) => {




  return `/public/checkout/${token}/customer`
}

export const submitPublicCustomerInfo = async (token: string,
    customerInfoDto: CustomerInfoDto, options?: RequestInit): Promise<submitPublicCustomerInfoResponse> => {

  return customInstance<submitPublicCustomerInfoResponse>(getSubmitPublicCustomerInfoUrl(token),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customerInfoDto,)
  }
);}




export const getSubmitPublicCustomerInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPublicCustomerInfo>>, TError,{token: string;data: CustomerInfoDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitPublicCustomerInfo>>, TError,{token: string;data: CustomerInfoDto}, TContext> => {

const mutationKey = ['submitPublicCustomerInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitPublicCustomerInfo>>, {token: string;data: CustomerInfoDto}> = (props) => {
          const {token,data} = props ?? {};

          return  submitPublicCustomerInfo(token,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitPublicCustomerInfoMutationResult = NonNullable<Awaited<ReturnType<typeof submitPublicCustomerInfo>>>
    export type SubmitPublicCustomerInfoMutationBody = CustomerInfoDto
    export type SubmitPublicCustomerInfoMutationError = unknown

    /**
 * @summary ثبت/اصلاح اطلاعات مشتری
 */
export const useSubmitPublicCustomerInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitPublicCustomerInfo>>, TError,{token: string;data: CustomerInfoDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitPublicCustomerInfo>>,
        TError,
        {token: string;data: CustomerInfoDto},
        TContext
      > => {
      return useMutation(getSubmitPublicCustomerInfoMutationOptions(options), queryClient);
    }

/**
 * @summary آغاز پرداخت آنلاین
 */
export type payPublicCheckoutResponse200 = {
  data: ResponsePublicPayDto
  status: 200
}

export type payPublicCheckoutResponseSuccess = (payPublicCheckoutResponse200) & {
  headers: Headers;
};
;

export type payPublicCheckoutResponse = (payPublicCheckoutResponseSuccess)

export const getPayPublicCheckoutUrl = (token: string,) => {




  return `/public/checkout/${token}/pay`
}

export const payPublicCheckout = async (token: string, options?: RequestInit): Promise<payPublicCheckoutResponse> => {

  return customInstance<payPublicCheckoutResponse>(getPayPublicCheckoutUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}




export const getPayPublicCheckoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payPublicCheckout>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof payPublicCheckout>>, TError,{token: string}, TContext> => {

const mutationKey = ['payPublicCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof payPublicCheckout>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  payPublicCheckout(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PayPublicCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof payPublicCheckout>>>

    export type PayPublicCheckoutMutationError = unknown

    /**
 * @summary آغاز پرداخت آنلاین
 */
export const usePayPublicCheckout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof payPublicCheckout>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof payPublicCheckout>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getPayPublicCheckoutMutationOptions(options), queryClient);
    }

/**
 * @summary نتیجه پرداخت
 */
export type getPublicCheckoutResultResponse200 = {
  data: ResponsePublicResultDto
  status: 200
}

export type getPublicCheckoutResultResponseSuccess = (getPublicCheckoutResultResponse200) & {
  headers: Headers;
};
;

export type getPublicCheckoutResultResponse = (getPublicCheckoutResultResponseSuccess)

export const getGetPublicCheckoutResultUrl = (token: string,) => {




  return `/public/checkout/${token}/result`
}

export const getPublicCheckoutResult = async (token: string, options?: RequestInit): Promise<getPublicCheckoutResultResponse> => {

  return customInstance<getPublicCheckoutResultResponse>(getGetPublicCheckoutResultUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicCheckoutResultQueryKey = (token: string,) => {
    return [
    `/public/checkout/${token}/result`
    ] as const;
    }


export const getGetPublicCheckoutResultQueryOptions = <TData = Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicCheckoutResultQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicCheckoutResult>>> = ({ signal }) => getPublicCheckoutResult(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicCheckoutResultQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicCheckoutResult>>>
export type GetPublicCheckoutResultQueryError = unknown


export function useGetPublicCheckoutResult<TData = Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCheckoutResult>>,
          TError,
          Awaited<ReturnType<typeof getPublicCheckoutResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCheckoutResult<TData = Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicCheckoutResult>>,
          TError,
          Awaited<ReturnType<typeof getPublicCheckoutResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicCheckoutResult<TData = Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary نتیجه پرداخت
 */

export function useGetPublicCheckoutResult<TData = Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicCheckoutResult>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicCheckoutResultQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary دریافت تنظیمات فروشگاه
 */
export type getStoreSettingsResponse200 = {
  data: ResponseStoreSettingsDto
  status: 200
}

export type getStoreSettingsResponseSuccess = (getStoreSettingsResponse200) & {
  headers: Headers;
};
;

export type getStoreSettingsResponse = (getStoreSettingsResponseSuccess)

export const getGetStoreSettingsUrl = (storeId: number,) => {




  return `/stores/${storeId}/settings`
}

export const getStoreSettings = async (storeId: number, options?: RequestInit): Promise<getStoreSettingsResponse> => {

  return customInstance<getStoreSettingsResponse>(getGetStoreSettingsUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreSettingsQueryKey = (storeId: number,) => {
    return [
    `/stores/${storeId}/settings`
    ] as const;
    }


export const getGetStoreSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getStoreSettings>>, TError = unknown>(storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreSettingsQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreSettings>>> = ({ signal }) => getStoreSettings(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(storeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoreSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreSettings>>>
export type GetStoreSettingsQueryError = unknown


export function useGetStoreSettings<TData = Awaited<ReturnType<typeof getStoreSettings>>, TError = unknown>(
 storeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreSettings>>,
          TError,
          Awaited<ReturnType<typeof getStoreSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreSettings<TData = Awaited<ReturnType<typeof getStoreSettings>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreSettings>>,
          TError,
          Awaited<ReturnType<typeof getStoreSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreSettings<TData = Awaited<ReturnType<typeof getStoreSettings>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دریافت تنظیمات فروشگاه
 */

export function useGetStoreSettings<TData = Awaited<ReturnType<typeof getStoreSettings>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoreSettingsQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary به‌روزرسانی تنظیمات فروشگاه
 */
export type updateStoreSettingsResponse200 = {
  data: ResponseStoreSettingsDto
  status: 200
}

export type updateStoreSettingsResponseSuccess = (updateStoreSettingsResponse200) & {
  headers: Headers;
};
;

export type updateStoreSettingsResponse = (updateStoreSettingsResponseSuccess)

export const getUpdateStoreSettingsUrl = (storeId: number,) => {




  return `/stores/${storeId}/settings`
}

export const updateStoreSettings = async (storeId: number,
    updateStoreSettingsDto: UpdateStoreSettingsDto, options?: RequestInit): Promise<updateStoreSettingsResponse> => {

  return customInstance<updateStoreSettingsResponse>(getUpdateStoreSettingsUrl(storeId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateStoreSettingsDto,)
  }
);}




export const getUpdateStoreSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoreSettings>>, TError,{storeId: number;data: UpdateStoreSettingsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoreSettings>>, TError,{storeId: number;data: UpdateStoreSettingsDto}, TContext> => {

const mutationKey = ['updateStoreSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoreSettings>>, {storeId: number;data: UpdateStoreSettingsDto}> = (props) => {
          const {storeId,data} = props ?? {};

          return  updateStoreSettings(storeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoreSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoreSettings>>>
    export type UpdateStoreSettingsMutationBody = UpdateStoreSettingsDto
    export type UpdateStoreSettingsMutationError = unknown

    /**
 * @summary به‌روزرسانی تنظیمات فروشگاه
 */
export const useUpdateStoreSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoreSettings>>, TError,{storeId: number;data: UpdateStoreSettingsDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStoreSettings>>,
        TError,
        {storeId: number;data: UpdateStoreSettingsDto},
        TContext
      > => {
      return useMutation(getUpdateStoreSettingsMutationOptions(options), queryClient);
    }

/**
 * @summary خلاصه آمار داشبورد
 */
export type getDashboardSummaryResponse200 = {
  data: ResponseDashboardSummaryDto
  status: 200
}

export type getDashboardSummaryResponseSuccess = (getDashboardSummaryResponse200) & {
  headers: Headers;
};
;

export type getDashboardSummaryResponse = (getDashboardSummaryResponseSuccess)

export const getGetDashboardSummaryUrl = (params?: GetDashboardSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/dashboard/summary?${stringifiedParams}` : `/dashboard/summary`
}

export const getDashboardSummary = async (params?: GetDashboardSummaryParams, options?: RequestInit): Promise<getDashboardSummaryResponse> => {

  return customInstance<getDashboardSummaryResponse>(getGetDashboardSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = (params?: GetDashboardSummaryParams,) => {
    return [
    `/dashboard/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = unknown


export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
 params: undefined |  GetDashboardSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
 params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
 params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary خلاصه آمار داشبورد
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
 params?: GetDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary دعوت‌نامه‌های در انتظار پذیرش
 */
export type getStoreInvitesResponse200 = {
  data: ResponseStoreInviteViewsDto
  status: 200
}

export type getStoreInvitesResponseSuccess = (getStoreInvitesResponse200) & {
  headers: Headers;
};
;

export type getStoreInvitesResponse = (getStoreInvitesResponseSuccess)

export const getGetStoreInvitesUrl = (storeId: number,) => {




  return `/stores/${storeId}/invites`
}

export const getStoreInvites = async (storeId: number, options?: RequestInit): Promise<getStoreInvitesResponse> => {

  return customInstance<getStoreInvitesResponse>(getGetStoreInvitesUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreInvitesQueryKey = (storeId: number,) => {
    return [
    `/stores/${storeId}/invites`
    ] as const;
    }


export const getGetStoreInvitesQueryOptions = <TData = Awaited<ReturnType<typeof getStoreInvites>>, TError = unknown>(storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInvites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreInvitesQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreInvites>>> = ({ signal }) => getStoreInvites(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(storeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreInvites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoreInvitesQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreInvites>>>
export type GetStoreInvitesQueryError = unknown


export function useGetStoreInvites<TData = Awaited<ReturnType<typeof getStoreInvites>>, TError = unknown>(
 storeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInvites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreInvites>>,
          TError,
          Awaited<ReturnType<typeof getStoreInvites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreInvites<TData = Awaited<ReturnType<typeof getStoreInvites>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInvites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreInvites>>,
          TError,
          Awaited<ReturnType<typeof getStoreInvites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreInvites<TData = Awaited<ReturnType<typeof getStoreInvites>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInvites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary دعوت‌نامه‌های در انتظار پذیرش
 */

export function useGetStoreInvites<TData = Awaited<ReturnType<typeof getStoreInvites>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInvites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoreInvitesQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary دعوت همکار (پیامک لینک دعوت)
 */
export type createStoreInviteResponse201 = {
  data: ResponseStoreInviteViewDto
  status: 201
}

export type createStoreInviteResponseSuccess = (createStoreInviteResponse201) & {
  headers: Headers;
};
;

export type createStoreInviteResponse = (createStoreInviteResponseSuccess)

export const getCreateStoreInviteUrl = (storeId: number,) => {




  return `/stores/${storeId}/invites`
}

export const createStoreInvite = async (storeId: number,
    createStoreInviteDto: CreateStoreInviteDto, options?: RequestInit): Promise<createStoreInviteResponse> => {

  return customInstance<createStoreInviteResponse>(getCreateStoreInviteUrl(storeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createStoreInviteDto,)
  }
);}




export const getCreateStoreInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoreInvite>>, TError,{storeId: number;data: CreateStoreInviteDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createStoreInvite>>, TError,{storeId: number;data: CreateStoreInviteDto}, TContext> => {

const mutationKey = ['createStoreInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStoreInvite>>, {storeId: number;data: CreateStoreInviteDto}> = (props) => {
          const {storeId,data} = props ?? {};

          return  createStoreInvite(storeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStoreInviteMutationResult = NonNullable<Awaited<ReturnType<typeof createStoreInvite>>>
    export type CreateStoreInviteMutationBody = CreateStoreInviteDto
    export type CreateStoreInviteMutationError = unknown

    /**
 * @summary دعوت همکار (پیامک لینک دعوت)
 */
export const useCreateStoreInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStoreInvite>>, TError,{storeId: number;data: CreateStoreInviteDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStoreInvite>>,
        TError,
        {storeId: number;data: CreateStoreInviteDto},
        TContext
      > => {
      return useMutation(getCreateStoreInviteMutationOptions(options), queryClient);
    }

/**
 * @summary لغو دعوت‌نامه
 */
export type deleteStoreInviteResponse200 = {
  data: ResponseStoreInviteDto
  status: 200
}

export type deleteStoreInviteResponseSuccess = (deleteStoreInviteResponse200) & {
  headers: Headers;
};
;

export type deleteStoreInviteResponse = (deleteStoreInviteResponseSuccess)

export const getDeleteStoreInviteUrl = (storeId: number,
    inviteId: number,) => {




  return `/stores/${storeId}/invites/${inviteId}`
}

export const deleteStoreInvite = async (storeId: number,
    inviteId: number, options?: RequestInit): Promise<deleteStoreInviteResponse> => {

  return customInstance<deleteStoreInviteResponse>(getDeleteStoreInviteUrl(storeId,inviteId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteStoreInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoreInvite>>, TError,{storeId: number;inviteId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStoreInvite>>, TError,{storeId: number;inviteId: number}, TContext> => {

const mutationKey = ['deleteStoreInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStoreInvite>>, {storeId: number;inviteId: number}> = (props) => {
          const {storeId,inviteId} = props ?? {};

          return  deleteStoreInvite(storeId,inviteId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteStoreInviteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStoreInvite>>>

    export type DeleteStoreInviteMutationError = unknown

    /**
 * @summary لغو دعوت‌نامه
 */
export const useDeleteStoreInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStoreInvite>>, TError,{storeId: number;inviteId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStoreInvite>>,
        TError,
        {storeId: number;inviteId: number},
        TContext
      > => {
      return useMutation(getDeleteStoreInviteMutationOptions(options), queryClient);
    }

/**
 * @summary نقش‌های قابل انتخاب برای اعضای تیم
 */
export type getTeamRolesResponse200 = {
  data: ResponseTeamRolesDto
  status: 200
}

export type getTeamRolesResponseSuccess = (getTeamRolesResponse200) & {
  headers: Headers;
};
;

export type getTeamRolesResponse = (getTeamRolesResponseSuccess)

export const getGetTeamRolesUrl = () => {




  return `/team-roles`
}

export const getTeamRoles = async ( options?: RequestInit): Promise<getTeamRolesResponse> => {

  return customInstance<getTeamRolesResponse>(getGetTeamRolesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamRolesQueryKey = () => {
    return [
    `/team-roles`
    ] as const;
    }


export const getGetTeamRolesQueryOptions = <TData = Awaited<ReturnType<typeof getTeamRoles>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamRolesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamRoles>>> = ({ signal }) => getTeamRoles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamRoles>>>
export type GetTeamRolesQueryError = unknown


export function useGetTeamRoles<TData = Awaited<ReturnType<typeof getTeamRoles>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamRoles>>,
          TError,
          Awaited<ReturnType<typeof getTeamRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamRoles<TData = Awaited<ReturnType<typeof getTeamRoles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamRoles>>,
          TError,
          Awaited<ReturnType<typeof getTeamRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamRoles<TData = Awaited<ReturnType<typeof getTeamRoles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary نقش‌های قابل انتخاب برای اعضای تیم
 */

export function useGetTeamRoles<TData = Awaited<ReturnType<typeof getTeamRoles>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamRoles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamRolesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary اعضای تیم فروشگاه
 */
export type getStoreMembersResponse200 = {
  data: ResponseStoreMembersDto
  status: 200
}

export type getStoreMembersResponseSuccess = (getStoreMembersResponse200) & {
  headers: Headers;
};
;

export type getStoreMembersResponse = (getStoreMembersResponseSuccess)

export const getGetStoreMembersUrl = (storeId: number,) => {




  return `/stores/${storeId}/members`
}

export const getStoreMembers = async (storeId: number, options?: RequestInit): Promise<getStoreMembersResponse> => {

  return customInstance<getStoreMembersResponse>(getGetStoreMembersUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreMembersQueryKey = (storeId: number,) => {
    return [
    `/stores/${storeId}/members`
    ] as const;
    }


export const getGetStoreMembersQueryOptions = <TData = Awaited<ReturnType<typeof getStoreMembers>>, TError = unknown>(storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreMembersQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreMembers>>> = ({ signal }) => getStoreMembers(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(storeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoreMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreMembers>>>
export type GetStoreMembersQueryError = unknown


export function useGetStoreMembers<TData = Awaited<ReturnType<typeof getStoreMembers>>, TError = unknown>(
 storeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreMembers>>,
          TError,
          Awaited<ReturnType<typeof getStoreMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreMembers<TData = Awaited<ReturnType<typeof getStoreMembers>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreMembers>>,
          TError,
          Awaited<ReturnType<typeof getStoreMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreMembers<TData = Awaited<ReturnType<typeof getStoreMembers>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary اعضای تیم فروشگاه
 */

export function useGetStoreMembers<TData = Awaited<ReturnType<typeof getStoreMembers>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoreMembersQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary تغییر نقش عضو تیم
 */
export type updateStoreMemberRoleResponse200 = {
  data: ResponseStoreMemberDto
  status: 200
}

export type updateStoreMemberRoleResponseSuccess = (updateStoreMemberRoleResponse200) & {
  headers: Headers;
};
;

export type updateStoreMemberRoleResponse = (updateStoreMemberRoleResponseSuccess)

export const getUpdateStoreMemberRoleUrl = (storeId: number,
    userId: number,) => {




  return `/stores/${storeId}/members/${userId}`
}

export const updateStoreMemberRole = async (storeId: number,
    userId: number,
    updateMemberRoleDto: UpdateMemberRoleDto, options?: RequestInit): Promise<updateStoreMemberRoleResponse> => {

  return customInstance<updateStoreMemberRoleResponse>(getUpdateStoreMemberRoleUrl(storeId,userId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateMemberRoleDto,)
  }
);}




export const getUpdateStoreMemberRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoreMemberRole>>, TError,{storeId: number;userId: number;data: UpdateMemberRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStoreMemberRole>>, TError,{storeId: number;userId: number;data: UpdateMemberRoleDto}, TContext> => {

const mutationKey = ['updateStoreMemberRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStoreMemberRole>>, {storeId: number;userId: number;data: UpdateMemberRoleDto}> = (props) => {
          const {storeId,userId,data} = props ?? {};

          return  updateStoreMemberRole(storeId,userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateStoreMemberRoleMutationResult = NonNullable<Awaited<ReturnType<typeof updateStoreMemberRole>>>
    export type UpdateStoreMemberRoleMutationBody = UpdateMemberRoleDto
    export type UpdateStoreMemberRoleMutationError = unknown

    /**
 * @summary تغییر نقش عضو تیم
 */
export const useUpdateStoreMemberRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStoreMemberRole>>, TError,{storeId: number;userId: number;data: UpdateMemberRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStoreMemberRole>>,
        TError,
        {storeId: number;userId: number;data: UpdateMemberRoleDto},
        TContext
      > => {
      return useMutation(getUpdateStoreMemberRoleMutationOptions(options), queryClient);
    }

/**
 * @summary حذف عضو از تیم (دسترسی او قطع می‌شود)
 */
export type removeStoreMemberResponse200 = {
  data: OkBaseResponse
  status: 200
}

export type removeStoreMemberResponseSuccess = (removeStoreMemberResponse200) & {
  headers: Headers;
};
;

export type removeStoreMemberResponse = (removeStoreMemberResponseSuccess)

export const getRemoveStoreMemberUrl = (storeId: number,
    userId: number,) => {




  return `/stores/${storeId}/members/${userId}`
}

export const removeStoreMember = async (storeId: number,
    userId: number, options?: RequestInit): Promise<removeStoreMemberResponse> => {

  return customInstance<removeStoreMemberResponse>(getRemoveStoreMemberUrl(storeId,userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveStoreMemberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStoreMember>>, TError,{storeId: number;userId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeStoreMember>>, TError,{storeId: number;userId: number}, TContext> => {

const mutationKey = ['removeStoreMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeStoreMember>>, {storeId: number;userId: number}> = (props) => {
          const {storeId,userId} = props ?? {};

          return  removeStoreMember(storeId,userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveStoreMemberMutationResult = NonNullable<Awaited<ReturnType<typeof removeStoreMember>>>

    export type RemoveStoreMemberMutationError = unknown

    /**
 * @summary حذف عضو از تیم (دسترسی او قطع می‌شود)
 */
export const useRemoveStoreMember = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeStoreMember>>, TError,{storeId: number;userId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeStoreMember>>,
        TError,
        {storeId: number;userId: number},
        TContext
      > => {
      return useMutation(getRemoveStoreMemberMutationOptions(options), queryClient);
    }

/**
 * @summary پذیرش دعوت‌نامه
 */
export type acceptStoreInviteResponse200 = {
  data: ResponseAcceptInviteDto
  status: 200
}

export type acceptStoreInviteResponseSuccess = (acceptStoreInviteResponse200) & {
  headers: Headers;
};
;

export type acceptStoreInviteResponse = (acceptStoreInviteResponseSuccess)

export const getAcceptStoreInviteUrl = (token: string,) => {




  return `/invites/${token}/accept`
}

export const acceptStoreInvite = async (token: string, options?: RequestInit): Promise<acceptStoreInviteResponse> => {

  return customInstance<acceptStoreInviteResponse>(getAcceptStoreInviteUrl(token),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAcceptStoreInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptStoreInvite>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptStoreInvite>>, TError,{token: string}, TContext> => {

const mutationKey = ['acceptStoreInvite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptStoreInvite>>, {token: string}> = (props) => {
          const {token} = props ?? {};

          return  acceptStoreInvite(token,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptStoreInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptStoreInvite>>>

    export type AcceptStoreInviteMutationError = unknown

    /**
 * @summary پذیرش دعوت‌نامه
 */
export const useAcceptStoreInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptStoreInvite>>, TError,{token: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptStoreInvite>>,
        TError,
        {token: string},
        TContext
      > => {
      return useMutation(getAcceptStoreInviteMutationOptions(options), queryClient);
    }

/**
 * @summary اطلاعات عمومی دعوت‌نامه
 */
export type getPublicInviteResponse200 = {
  data: ResponsePublicInviteDto
  status: 200
}

export type getPublicInviteResponseSuccess = (getPublicInviteResponse200) & {
  headers: Headers;
};
;

export type getPublicInviteResponse = (getPublicInviteResponseSuccess)

export const getGetPublicInviteUrl = (token: string,) => {




  return `/public/invites/${token}`
}

export const getPublicInvite = async (token: string, options?: RequestInit): Promise<getPublicInviteResponse> => {

  return customInstance<getPublicInviteResponse>(getGetPublicInviteUrl(token),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicInviteQueryKey = (token: string,) => {
    return [
    `/public/invites/${token}`
    ] as const;
    }


export const getGetPublicInviteQueryOptions = <TData = Awaited<ReturnType<typeof getPublicInvite>>, TError = unknown>(token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicInvite>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicInviteQueryKey(token);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicInvite>>> = ({ signal }) => getPublicInvite(token, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(token), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicInvite>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicInviteQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicInvite>>>
export type GetPublicInviteQueryError = unknown


export function useGetPublicInvite<TData = Awaited<ReturnType<typeof getPublicInvite>>, TError = unknown>(
 token: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicInvite>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicInvite>>,
          TError,
          Awaited<ReturnType<typeof getPublicInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicInvite<TData = Awaited<ReturnType<typeof getPublicInvite>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicInvite>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicInvite>>,
          TError,
          Awaited<ReturnType<typeof getPublicInvite>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicInvite<TData = Awaited<ReturnType<typeof getPublicInvite>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicInvite>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary اطلاعات عمومی دعوت‌نامه
 */

export function useGetPublicInvite<TData = Awaited<ReturnType<typeof getPublicInvite>>, TError = unknown>(
 token: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicInvite>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicInviteQueryOptions(token,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary خروجی اکسل سفارش‌ها
 */
export type exportOrdersResponse200 = {
  data: void
  status: 200
}

export type exportOrdersResponseSuccess = (exportOrdersResponse200) & {
  headers: Headers;
};
;

export type exportOrdersResponse = (exportOrdersResponseSuccess)

export const getExportOrdersUrl = (params: ExportOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/exports/orders?${stringifiedParams}` : `/exports/orders`
}

export const exportOrders = async (params: ExportOrdersParams, options?: RequestInit): Promise<exportOrdersResponse> => {

  return customInstance<exportOrdersResponse>(getExportOrdersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportOrdersQueryKey = (params?: ExportOrdersParams,) => {
    return [
    `/exports/orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportOrdersQueryOptions = <TData = Awaited<ReturnType<typeof exportOrders>>, TError = unknown>(params: ExportOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportOrdersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportOrders>>> = ({ signal }) => exportOrders(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof exportOrders>>>
export type ExportOrdersQueryError = unknown


export function useExportOrders<TData = Awaited<ReturnType<typeof exportOrders>>, TError = unknown>(
 params: ExportOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrders>>,
          TError,
          Awaited<ReturnType<typeof exportOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrders<TData = Awaited<ReturnType<typeof exportOrders>>, TError = unknown>(
 params: ExportOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrders>>,
          TError,
          Awaited<ReturnType<typeof exportOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportOrders<TData = Awaited<ReturnType<typeof exportOrders>>, TError = unknown>(
 params: ExportOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary خروجی اکسل سفارش‌ها
 */

export function useExportOrders<TData = Awaited<ReturnType<typeof exportOrders>>, TError = unknown>(
 params: ExportOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportOrders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary خروجی اکسل مشتریان
 */
export type exportCustomersResponse200 = {
  data: void
  status: 200
}

export type exportCustomersResponseSuccess = (exportCustomersResponse200) & {
  headers: Headers;
};
;

export type exportCustomersResponse = (exportCustomersResponseSuccess)

export const getExportCustomersUrl = (params: ExportCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/exports/customers?${stringifiedParams}` : `/exports/customers`
}

export const exportCustomers = async (params: ExportCustomersParams, options?: RequestInit): Promise<exportCustomersResponse> => {

  return customInstance<exportCustomersResponse>(getExportCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportCustomersQueryKey = (params?: ExportCustomersParams,) => {
    return [
    `/exports/customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportCustomersQueryOptions = <TData = Awaited<ReturnType<typeof exportCustomers>>, TError = unknown>(params: ExportCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportCustomers>>> = ({ signal }) => exportCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof exportCustomers>>>
export type ExportCustomersQueryError = unknown


export function useExportCustomers<TData = Awaited<ReturnType<typeof exportCustomers>>, TError = unknown>(
 params: ExportCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCustomers>>,
          TError,
          Awaited<ReturnType<typeof exportCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCustomers<TData = Awaited<ReturnType<typeof exportCustomers>>, TError = unknown>(
 params: ExportCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportCustomers>>,
          TError,
          Awaited<ReturnType<typeof exportCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportCustomers<TData = Awaited<ReturnType<typeof exportCustomers>>, TError = unknown>(
 params: ExportCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary خروجی اکسل مشتریان
 */

export function useExportCustomers<TData = Awaited<ReturnType<typeof exportCustomers>>, TError = unknown>(
 params: ExportCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary خروجی اکسل محصولات
 */
export type exportProductsResponse200 = {
  data: void
  status: 200
}

export type exportProductsResponseSuccess = (exportProductsResponse200) & {
  headers: Headers;
};
;

export type exportProductsResponse = (exportProductsResponseSuccess)

export const getExportProductsUrl = (params: ExportProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/exports/products?${stringifiedParams}` : `/exports/products`
}

export const exportProducts = async (params: ExportProductsParams, options?: RequestInit): Promise<exportProductsResponse> => {

  return customInstance<exportProductsResponse>(getExportProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportProductsQueryKey = (params?: ExportProductsParams,) => {
    return [
    `/exports/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportProductsQueryOptions = <TData = Awaited<ReturnType<typeof exportProducts>>, TError = unknown>(params: ExportProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportProducts>>> = ({ signal }) => exportProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExportProductsQueryResult = NonNullable<Awaited<ReturnType<typeof exportProducts>>>
export type ExportProductsQueryError = unknown


export function useExportProducts<TData = Awaited<ReturnType<typeof exportProducts>>, TError = unknown>(
 params: ExportProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportProducts>>,
          TError,
          Awaited<ReturnType<typeof exportProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportProducts<TData = Awaited<ReturnType<typeof exportProducts>>, TError = unknown>(
 params: ExportProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportProducts>>,
          TError,
          Awaited<ReturnType<typeof exportProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExportProducts<TData = Awaited<ReturnType<typeof exportProducts>>, TError = unknown>(
 params: ExportProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary خروجی اکسل محصولات
 */

export function useExportProducts<TData = Awaited<ReturnType<typeof exportProducts>>, TError = unknown>(
 params: ExportProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExportProductsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary پیگیری عمومی سفارش پرداخت‌شده
 */
export type getPublicTrackingResponse200 = {
  data: ResponsePublicTrackingDto
  status: 200
}

export type getPublicTrackingResponseSuccess = (getPublicTrackingResponse200) & {
  headers: Headers;
};
;

export type getPublicTrackingResponse = (getPublicTrackingResponseSuccess)

export const getGetPublicTrackingUrl = (trackingUuid: string,) => {




  return `/public/tracking/${trackingUuid}`
}

export const getPublicTracking = async (trackingUuid: string, options?: RequestInit): Promise<getPublicTrackingResponse> => {

  return customInstance<getPublicTrackingResponse>(getGetPublicTrackingUrl(trackingUuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicTrackingQueryKey = (trackingUuid: string,) => {
    return [
    `/public/tracking/${trackingUuid}`
    ] as const;
    }


export const getGetPublicTrackingQueryOptions = <TData = Awaited<ReturnType<typeof getPublicTracking>>, TError = unknown>(trackingUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTracking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicTrackingQueryKey(trackingUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicTracking>>> = ({ signal }) => getPublicTracking(trackingUuid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(trackingUuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicTracking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicTrackingQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicTracking>>>
export type GetPublicTrackingQueryError = unknown


export function useGetPublicTracking<TData = Awaited<ReturnType<typeof getPublicTracking>>, TError = unknown>(
 trackingUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTracking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTracking>>,
          TError,
          Awaited<ReturnType<typeof getPublicTracking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicTracking<TData = Awaited<ReturnType<typeof getPublicTracking>>, TError = unknown>(
 trackingUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTracking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicTracking>>,
          TError,
          Awaited<ReturnType<typeof getPublicTracking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicTracking<TData = Awaited<ReturnType<typeof getPublicTracking>>, TError = unknown>(
 trackingUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTracking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary پیگیری عمومی سفارش پرداخت‌شده
 */

export function useGetPublicTracking<TData = Awaited<ReturnType<typeof getPublicTracking>>, TError = unknown>(
 trackingUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicTracking>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicTrackingQueryOptions(trackingUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * کاربر را به لینک برگشتی هدایت کنید؛ پس از تایید در اینستاگرام به INSTAGRAM_RESULT_URL برمی‌گردد.
 * @summary لینک اتصال حساب اینستاگرام به فروشگاه
 */
export type getInstagramConnectUrlResponse200 = {
  data: ResponseInstagramConnectUrlDto
  status: 200
}

export type getInstagramConnectUrlResponseSuccess = (getInstagramConnectUrlResponse200) & {
  headers: Headers;
};
;

export type getInstagramConnectUrlResponse = (getInstagramConnectUrlResponseSuccess)

export const getGetInstagramConnectUrlUrl = (storeId: number,) => {




  return `/instagram/stores/${storeId}/connect-url`
}

export const getInstagramConnectUrl = async (storeId: number, options?: RequestInit): Promise<getInstagramConnectUrlResponse> => {

  return customInstance<getInstagramConnectUrlResponse>(getGetInstagramConnectUrlUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInstagramConnectUrlQueryKey = (storeId: number,) => {
    return [
    `/instagram/stores/${storeId}/connect-url`
    ] as const;
    }


export const getGetInstagramConnectUrlQueryOptions = <TData = Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError = unknown>(storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstagramConnectUrlQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstagramConnectUrl>>> = ({ signal }) => getInstagramConnectUrl(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(storeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstagramConnectUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getInstagramConnectUrl>>>
export type GetInstagramConnectUrlQueryError = unknown


export function useGetInstagramConnectUrl<TData = Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError = unknown>(
 storeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstagramConnectUrl>>,
          TError,
          Awaited<ReturnType<typeof getInstagramConnectUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstagramConnectUrl<TData = Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstagramConnectUrl>>,
          TError,
          Awaited<ReturnType<typeof getInstagramConnectUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstagramConnectUrl<TData = Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary لینک اتصال حساب اینستاگرام به فروشگاه
 */

export function useGetInstagramConnectUrl<TData = Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstagramConnectUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstagramConnectUrlQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary وضعیت حساب اینستاگرام متصل به فروشگاه
 */
export type getStoreInstagramAccountResponse200 = {
  data: ResponseInstagramAccountDto
  status: 200
}

export type getStoreInstagramAccountResponseSuccess = (getStoreInstagramAccountResponse200) & {
  headers: Headers;
};
;

export type getStoreInstagramAccountResponse = (getStoreInstagramAccountResponseSuccess)

export const getGetStoreInstagramAccountUrl = (storeId: number,) => {




  return `/instagram/stores/${storeId}`
}

export const getStoreInstagramAccount = async (storeId: number, options?: RequestInit): Promise<getStoreInstagramAccountResponse> => {

  return customInstance<getStoreInstagramAccountResponse>(getGetStoreInstagramAccountUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStoreInstagramAccountQueryKey = (storeId: number,) => {
    return [
    `/instagram/stores/${storeId}`
    ] as const;
    }


export const getGetStoreInstagramAccountQueryOptions = <TData = Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError = unknown>(storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStoreInstagramAccountQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStoreInstagramAccount>>> = ({ signal }) => getStoreInstagramAccount(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(storeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStoreInstagramAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getStoreInstagramAccount>>>
export type GetStoreInstagramAccountQueryError = unknown


export function useGetStoreInstagramAccount<TData = Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError = unknown>(
 storeId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreInstagramAccount>>,
          TError,
          Awaited<ReturnType<typeof getStoreInstagramAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreInstagramAccount<TData = Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoreInstagramAccount>>,
          TError,
          Awaited<ReturnType<typeof getStoreInstagramAccount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStoreInstagramAccount<TData = Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary وضعیت حساب اینستاگرام متصل به فروشگاه
 */

export function useGetStoreInstagramAccount<TData = Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError = unknown>(
 storeId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStoreInstagramAccount>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStoreInstagramAccountQueryOptions(storeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary قطع اتصال حساب اینستاگرام از فروشگاه
 */
export type disconnectInstagramAccountResponse200 = {
  data: ResponseInstagramAccountDto
  status: 200
}

export type disconnectInstagramAccountResponseSuccess = (disconnectInstagramAccountResponse200) & {
  headers: Headers;
};
;

export type disconnectInstagramAccountResponse = (disconnectInstagramAccountResponseSuccess)

export const getDisconnectInstagramAccountUrl = (storeId: number,) => {




  return `/instagram/stores/${storeId}`
}

export const disconnectInstagramAccount = async (storeId: number, options?: RequestInit): Promise<disconnectInstagramAccountResponse> => {

  return customInstance<disconnectInstagramAccountResponse>(getDisconnectInstagramAccountUrl(storeId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDisconnectInstagramAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectInstagramAccount>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof disconnectInstagramAccount>>, TError,{storeId: number}, TContext> => {

const mutationKey = ['disconnectInstagramAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectInstagramAccount>>, {storeId: number}> = (props) => {
          const {storeId} = props ?? {};

          return  disconnectInstagramAccount(storeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectInstagramAccountMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectInstagramAccount>>>

    export type DisconnectInstagramAccountMutationError = unknown

    /**
 * @summary قطع اتصال حساب اینستاگرام از فروشگاه
 */
export const useDisconnectInstagramAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectInstagramAccount>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectInstagramAccount>>,
        TError,
        {storeId: number},
        TContext
      > => {
      return useMutation(getDisconnectInstagramAccountMutationOptions(options), queryClient);
    }

/**
 * @summary فعال‌سازی دوباره دریافت رویدادها (webhook)
 */
export type resubscribeInstagramWebhooksResponse200 = {
  data: ResponseInstagramAccountDto
  status: 200
}

export type resubscribeInstagramWebhooksResponseSuccess = (resubscribeInstagramWebhooksResponse200) & {
  headers: Headers;
};
;

export type resubscribeInstagramWebhooksResponse = (resubscribeInstagramWebhooksResponseSuccess)

export const getResubscribeInstagramWebhooksUrl = (storeId: number,) => {




  return `/instagram/stores/${storeId}/resubscribe`
}

export const resubscribeInstagramWebhooks = async (storeId: number, options?: RequestInit): Promise<resubscribeInstagramWebhooksResponse> => {

  return customInstance<resubscribeInstagramWebhooksResponse>(getResubscribeInstagramWebhooksUrl(storeId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getResubscribeInstagramWebhooksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resubscribeInstagramWebhooks>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resubscribeInstagramWebhooks>>, TError,{storeId: number}, TContext> => {

const mutationKey = ['resubscribeInstagramWebhooks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resubscribeInstagramWebhooks>>, {storeId: number}> = (props) => {
          const {storeId} = props ?? {};

          return  resubscribeInstagramWebhooks(storeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResubscribeInstagramWebhooksMutationResult = NonNullable<Awaited<ReturnType<typeof resubscribeInstagramWebhooks>>>

    export type ResubscribeInstagramWebhooksMutationError = unknown

    /**
 * @summary فعال‌سازی دوباره دریافت رویدادها (webhook)
 */
export const useResubscribeInstagramWebhooks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resubscribeInstagramWebhooks>>, TError,{storeId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resubscribeInstagramWebhooks>>,
        TError,
        {storeId: number},
        TContext
      > => {
      return useMutation(getResubscribeInstagramWebhooksMutationOptions(options), queryClient);
    }

